<!-- 第三版询价单编辑-->
<template>
    <div class="purorder-v3" v-loading="searchApParams._visible" element-loading-spinner="none">
        <div>
            <div class="bread-nav">
                <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()"></el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" tabindex="-1" v-if="!dataReadonly">搜索配件(F2)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showAPMsgDialog()" tabindex="-1" v-if="!dataReadonly">查看配件信息(F3)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="analysis()" v-if="!dataReadonly">数据分析(F4)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="showSalesHistories()" v-if="!dataReadonly">销售历史(F5) </el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="showPurHistories()" v-if="!dataReadonly">采购历史(F6)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="showIntentDatas()" v-if="!dataReadonly">询价历史(F7) </el-button>
                <el-button size="small" class="search-btn btn-primary" @click="addCustomer(1)" v-if="!dataReadonly && permission.addSupplier">{{
                    permission.addSupplier }} (F9)</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="addCustomer(2)"
                    v-if="!dataReadonly && submitData.EntpCusId && permission.editSupplier">{{ permission.editSupplier }} (F10)
                </el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click.stop="showAddAPDialog">新增配件商品</el-button>
                <el-button size="small" class="search-btn btn-primary" @click.stop="submitForm()" v-if="!dataReadonly && permission.submit"
                    :disabled="!canRequest">{{ permission.submit }}(F11)</el-button>
            </div>
            <div :class="showOrderMsg ? 'section-title' : 'section-title section-magin'">
                <div>
                    <span>订单信息 {{ submitData.InquiryCode ? '【' + submitData.InquiryCode + '】' : '' }}</span>
                    <span v-show="!showOrderMsg && submitData.EntpCusName">&nbsp;&nbsp;&nbsp;&nbsp;供应商：{{ submitData.EntpCusName }}</span>
                    <span style="margin-left: 10px; font-weight: 500"> 【 询价总数：{{ allNum }} &nbsp;&nbsp; 询价总额：{{ allMoney }}】 </span>
                </div>
                <div class="flex" v-show="!showOrderMsg">
                    <div class="warhouse" v-if="submitData.WarehouseName">入仓仓库：{{ submitData.WarehouseName }}</div>
                    <div class="img-e-op" @click="showMsg">
                        <img src="../../../assets/images/down-e.png" />
                    </div>
                </div>
                <div class="flex" v-show="showOrderMsg">
                    <div class="warhouse" v-if="submitData.WarehouseName">入仓仓库：{{ submitData.WarehouseName }}</div>
                    <div class="img-e-op" @click="hideMsg">
                        <img src="../../../assets/images/up-e.png" />
                    </div>
                </div>
            </div>
            <div class="order-infoes" v-show="showOrderMsg">
                <el-form ref="form" label-width="95px" style="width: 100%; padding-right: 10px; padding-left: 10px" :rules="rules">
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="选择供应商" prop="EntpCusId">
                                    <el-select style="width: 100%" size="small" :disabled="type == 1" v-model="submitData.EntpCusId" filterable clearable remote
                                        :remote-method="searchCustomer" v-select-scroll-more="searchSupplierLoad" @change="customerChange($event)"
                                        @visible-change="customerVisibleChange($event)" reserve-keyword placeholder="选择供应商">
                                        <el-option v-for="optionItem in customerList" :key="optionItem.EntpCusId" :data-msg="optionItem"
                                            :label="optionItem.EntpCusName" :value="optionItem.EntpCusId"></el-option> </el-select></el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="入仓仓库" prop="WarehouseId" style="width: 100%">
                                    <el-input size="small" v-if="type == 1" :title="submitData.WarehouseName" v-model="submitData.WarehouseName" style="width: 100%"
                                        :disabled="true"></el-input>
                                    <el-select v-else size="small" style="width: 100%" v-model="submitData.WarehouseId" placeholder="请选择" filterable clearable
                                        @visible-change="warehouseVisibleChange($event)" @change="warehouseChange">
                                        <el-option v-for="item in warehouseList" :key="item.WarehouseId" :label="item.WarehouseName" :value="item.WarehouseId">
                                            <span style="float: left">{{ item.WarehouseName }}</span>
                                            <span v-if="item.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运费">
                                    <el-input min="0" size="small" type="number" step="0.01" style="width: 100%" :disabled="type == 1"
                                        v-model.trim="submitData.PriceSumShip"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="询价日期">
                                    <el-date-picker size="small" style="width: 100%" :disabled="type == 1" value-format="yyyy-MM-dd" v-model="submitData.QTime"
                                        type="date"></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="期限日期">
                                    <el-date-picker size="small" style="width: 100%" :disabled="type == 1" value-format="yyyy-MM-dd" v-model="submitData.NeedTime"
                                        type="date"></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div class="grid-content bg-purple">
                                <el-form-item label="报价日期">
                                    <el-date-picker size="small" style="width: 100%" :disabled="type == 1" value-format="yyyy-MM-dd" v-model="submitData.ITime"
                                        type="date"></el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <el-form-item label="备注">
                                    <el-input size="small" :disabled="type == 1" style="width: 100%" v-model.trim="submitData.Remark"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div :class="showResultMsg ? 'section-title' : 'section-title section-magin'" @click="hideMsg">
                <div>
                    <span>搜索配件结果</span>
                    <span style="margin-left: 10px; font-size: 14px">{{ tableDataLength > 0 ? '(结果数：' + tableDataLength + ')' : '' }}</span>
                </div>
                <div class="flex">
                    <el-button icon="el-icon-refresh" type="primary" class="search-set-btn" @click="refreshResult()"></el-button>
                    <el-button v-if="isCanTBSet" icon="el-icon-setting" type="primary" class="search-set-btn" @click="showTableSetDialog()"></el-button>
                    <div class="img-e-op" @click="showResultFunc" v-show="!showResultMsg">
                        <img src="../../../assets/images/down-e.png" />
                    </div>
                    <div class="img-e-op" @click="hideResultFunc" v-show="showResultMsg">
                        <img src="../../../assets/images/up-e.png" />
                    </div>
                </div>
            </div>
            <div @click="hideMsg" v-show="showResultMsg" class="search-in-order" style="margin-bottom: 5px">
                <ux-grid ref="multipleTable" height="336px" style="width: 100%" @cell-dblclick="dblChooseAps" @table-body-scroll="tableLoad" highlight-current-row
                    show-overflow v-loading="searchData.page == 1 ? searchLoading : false" :data="tableData" :row-class-name="tableRowClassName"
                    @row-click="rowClick" empty-text="" @sort-change="sortChange">
                    <template v-for="(col, index) in columnShowSets">
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-if="col.ColumnCode == 'APCode'" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }}</i>
                                <i v-else>{{ scope.row.APCode }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'GoodCode'" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodCode }}</i>
                                <i v-else>{{ scope.row.GoodCode }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'GoodName'" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodName }}</i>
                                <i v-else>{{ scope.row.GoodName }}</i>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'AutoSerise'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <el-tooltip placement="top">
                                    <div slot="content" v-html="$options.filters.AutoSeriseTextSplit(row.AutoSerise)"></div>
                                    <div class="tooltip-div">{{ row.AutoSerise }}</div>
                                </el-tooltip>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'Inventory'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span class="inven-active">{{ row.Inventory }}</span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'Remaining'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span class="out-active">
                                    {{ row.Inventory + (isAddWaitIn ? row.POrderWaitInQuantity : 0) - row.OrderWaitOutQuantity }}
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'SalesOutWHCout'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span>
                                    {{ row.SalesOutWHCout }}
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'OrderWaitOutQuantity'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span>
                                    <el-button @click="showNeedOutData(row)" type="text" style="padding: 0px" v-if="row.OrderWaitOutQuantity > 0">{{
                                        row.OrderWaitOutQuantity
                                    }}</el-button>
                                    <span v-else>{{ row.OrderWaitOutQuantity }}</span>
                                </span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'POrderWaitInQuantity'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span>
                                    <el-button @click="showNeedInData(row)" type="text" style="padding: 0px" v-if="row.POrderWaitInQuantity > 0">{{
                                        row.POrderWaitInQuantity
                                    }}</el-button>
                                    <span v-else>{{ row.POrderWaitInQuantity }}</span></span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'PlanPurchase'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span>{{ row.PlanPurchase }}</span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            v-else-if="col.ColumnCode == 'IntenCount'" show-overflow-tooltip>
                            <template v-slot="{ row }">
                                <span>
                                    <el-button v-if="row.IntenCount > 0" @click="showIntentCountDatas(row)" type="text" style="padding: 0px">{{
                                        row.IntenCount
                                    }}</el-button>
                                    <span v-else>{{ row.IntenCount }}</span></span>
                            </template>
                        </ux-table-column>
                        <ux-table-column v-bind:key="col.ColumnCode + index" :field="col.ColumnCode" :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                            :title="col.ColumnName" resizable :sortable="col.IsSort" :remote-sort="col.IsSort" header-align :prop="col.ColumnCode"
                            show-overflow-tooltip v-else>
                        </ux-table-column>
                    </template>
                </ux-grid>
                <div class="invens-summary" v-if="isShowSummary">
                    <span class="title">各仓库库存数据：</span>
                    <div v-for="item in summaryList" :key="item.Name" class="summary-item">
                        <span class="sname">【 {{ item.Name }} 】</span>
                        <span class="sname">库存数：</span>
                        <span class="scount"> {{ item.Count }} </span>
                    </div>
                </div>
            </div>
            <!--    table    -->
            <div class="section-title" @click="hideMsg()">
                <div>
                    订单商品明细
                    <span v-if="type == 7" style="font-size: 14px; margin-left: 10px; color: red">
                        （ 温馨提醒：已入仓的商品不能再进行修改！部分入仓的商品数量可修改，但不能少于已入仓数！ ）
                    </span>
                </div>
                <div>
                    <el-button size="small" class="search-btn btn-similar" @click="resetZeroHandle" v-if="showInitNumberBtn">清空商品数量为0</el-button>
                </div>
            </div>
        </div>
        <!-- table body -->
        <div id="infinite-list" class="pur-order-edit" @click="hideMsg()">
            <ux-grid ref="infiniteTable" :data="dataList" keep-source height="314px" :highlight-current-row="false" :edit-config="{ trigger: 'click', mode: 'row' }"
                :row-style="setRowStyle" row-id="rowkey">
                <ux-table-column class-name="table-sort" type="index" title="序号" width="64"></ux-table-column>
                <ux-table-column field="APCode" title="汽配编码" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <div class="head-view">
                            <span class="color-red">*</span>
                            {{ column.title }}
                            <span class="sort-view">
                                <i :class="['el-icon-caret-top', { active: sortActive === 'top' }]" title="升序,从小到大排序" @click="changeTableSort('top', 'APCode')"></i>
                                <i :class="['el-icon-caret-bottom', { active: sortActive === 'bottom' }]" title="降序,从大到小排序"
                                    @click="changeTableSort('bottom', 'APCode')"></i>
                            </span>
                        </div>
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['pur-apcode div-padding-12', { 'special-border': !row.APCode }]" @click="focusHandle(row.IsNew, rowIndex, 'sapcode')">
                            <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(row.EntpTempGoodsId)" />
                            <span>{{ row.APCode ? row.APCode : '请点击选中汽配编码' }}</span>
                            <el-tag v-if="row.State == 1" class="tag" type="warning">已删除</el-tag>
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select ref="sapcode" :disabled="dataReadonly" :allow-create="isCheckCode" default-first-option size="small" v-model="scope.row.APCode" value-key="APCode" filterable clearable
                            remote reserve-keyword placeholder="汽配编码" @change="codeChange($event, scope.rowIndex)" @visible-change="apCodeVisibleChange($event)"
                            :remote-method="query => {
                                    searchCode(query, scope.row, scope.rowIndex);
                                }
                                " v-select-scroll-more="searchCodeLoad" style="width: 100%" popper-class="el-select-style-gray"
                            @keyup.right.native="keyEvent($event, 'APCode')">
                            <el-option v-for="optionItem in codeList" :key="optionItem.EntpTempGoodsId" :data-msg="optionItem" :label="optionItem.APCode"
                                :value="isCheckCode ? optionItem.APCode : optionItem.EntpTempGoodsId">
                                <div class="option-content">
                                    <div class="project-Name">{{ optionItem.APCode }}</div>
                                    <div class="project-Name">{{ optionItem.GoodName }}</div>
                                    <div class="project-Name in-one-line">{{ optionItem.AutoSerise }}</div>
                                    <div class="project-Name" v-if="changeCodeConfig">{{ optionItem.GoodCode }}</div>
                                    <div class="project-iven" v-if="isInvenShow">{{ optionItem.DynaInven }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="GoodNameItem" title="配件名称" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <div :class="['div-padding-12', { 'special-border': !row.GoodName }]" @click="focusHandle(row.IsNew, row, 'partsNameSelect')">
                            {{ row.GoodName }}
                        </div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input size="small" placeholder="配件名称" ref="partsNameSelect" v-model="scope.row.GoodName" :disabled="dataReadonly ||
                            (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                            (type == 4 && !scope.row.canEdit) ||
                            (type == 7 && scope.row.WarehousedCount > 0)
                            " @keyup.right.native="keyEvent($event, 'GoodName')" @keyup.left.native="keyEvent($event, 'GoodName')"
                            @focus="selectAutoHandle('partsNameSelect')"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="AutoSeriseItem" title="车型" edit-render show-overflow-tooltip resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row, rowIndex }">
                        <el-tooltip effect="dark" :content="row.AutoSerise ? row.AutoSerise.toString() : ''" :disabled="!row.AutoSerise" placement="top">
                            <div :class="['div-padding-12', { 'special-border': !row.AutoSerise }]" @click="focusHandle(row.IsNew, row, 'autoSeriseSelect')">
                                {{ row.AutoSerise }}
                            </div>
                        </el-tooltip>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input size="small" v-model="scope.row.AutoSerise" placeholder="车系" :disabled="dataReadonly ||
                            (scope.row.hasLock && lastRowIndex !== scope.rowIndex) ||
                            (type == 4 && !scope.row.canEdit) ||
                            (type == 7 && scope.row.WarehousedCount > 0)
                            " @keyup.right.native="keyEvent($event, 'AutoSerise')" @keyup.left.native="keyEvent($event, 'AutoSerise')"
                            @focus="selectAutoHandle('autoSeriseSelect')" ref="autoSeriseSelect"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Brand" title="品牌" v-if="isShowBrand" width="90" resizable key="Brand">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Brand }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Origin" title="产地" v-if="isOriginShow" width="150" :edit-render="{ autofocus: '.el-input__inner' }" resizable key="origin">
                    <template v-slot="{ row }">
                        <div class="div-padding-12" @click="focusHandle('originRef')">{{ row.Origin }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input ref="originRef" size="small" v-model="scope.row.Origin" @keyup.right.native="keyEvent($event, 'Origin')"
                            @keyup.left.native="keyEvent($event, 'Origin')" @focus="selectAutoHandle('originRef')" :disabled="type == 1"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column field="Size" title="规格" v-if="isSizeShow" width="100" resizable key="Size">
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Size }}</div>
                    </template>
                </ux-table-column>
                <ux-table-column field="Count" title="数量" width="100" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Count }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number class="purcounts-input-cell" style="width: 100%" type="number" ref="countRef" :min="1" :precision="0"
                            controls-position="right" size="small" v-model="scope.row.Count" :disabled="type == 1" @change="priceChange"
                            @keyup.enter.native="keyEvent($event, 'Count')" @keyup.right.native="keyEvent($event, 'Count')"
                            @keyup.left.native="keyEvent($event, 'Count')" @focus="selectAutoHandle('countRef')"></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="Unit" title="单位" width="100" edit-render resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': !row.Unit }]" @click="focusHandle('unitSelect')">{{ row.Unit }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-select ref="unitSelect" default-first-option size="small" v-model="scope.row.Unit" filterable clearable remote reserve-keyword
                            placeholder="单位" @visible-change="unitVisibleChange($event)" :disabled="type == 1" 
                            @keyup.right.native="keyEvent($event, 'Unit')"
                            @keyup.left.native="keyEvent($event, 'Unit')"
                            popper-class="el-select-style-gray">
                            <el-option v-for="optionItem in unitList" :key="optionItem.Value" :label="optionItem.Value" :value="optionItem.Value"></el-option>
                        </el-select>
                    </template>
                </ux-table-column>
                <ux-table-column field="jhj" title="报价价格" width="130" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot:header="{ column }">
                        <span class="color-red">*</span>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div :class="['div-padding-12', { 'special-border': row.MarketPrice === 0 }]">{{ row.MarketPrice }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input-number class="sales-input-cell" ref="marketPirceRef" :min="0" :precision="2" :step="0.01" controls-position="right" size="small"
                            v-model="scope.row.MarketPrice" :disabled="type == 1" @keyup.enter.native="addItem(true)"
                            @keyup.left.native="keyEvent($event, 'MarketPrice')" @keyup.right.native="keyEvent($event, 'MarketPrice')"
                            @focus="selectAutoHandle('marketPirceRef')"></el-input-number>
                    </template>
                </ux-table-column>
                <ux-table-column field="cgzj" title="总价格" width="160" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12 div-margin-op">
                            <img src="@/assets/images/sup.png" title="采购历史" style="width: 27px; height: 27px" v-if="row.EntpTempGoodsId"
                                @click="showHistories(row.EntpTempGoodsId)" />
                            <img src="@/assets/images/cus.png" style="width: 26px; height: 26px; margin-right: 4px" title="销售历史" v-if="row.EntpTempGoodsId"
                                @click="showSaleStat(row)" />
                            <img src="@/assets/images/analysis.png" style="width: 23px; height: 23px; margin-right: 4px" title="数据分析" v-if="row.EntpTempGoodsId"
                                @click="analysis(row)" />
                            <span>
                                {{ row.MarketPrice * row.Count ? (row.MarketPrice * row.Count).toFixed(2) : 0 }}
                            </span>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="ly" title="留余" width="80" resizable>
                    <template v-slot:header="{ column }">
                        <el-tooltip effect="dark" placement="bottom">
                            <div slot="content">
                                {{ isAddWaitIn ? '留余=总库存数－总待出数＋总待入数' : '留余=总库存数－总待出数' }}
                                <br />注意：此处已统计退货商品的数量
                                <br />
                            </div>
                            <span>
                                <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                            </span>
                        </el-tooltip>
                        {{ column.title }}
                    </template>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">
                            <el-tooltip effect="dark" :content="'待入仓(' +
                                row.POrderWaitInQuantity +
                                '）  待出仓(' +
                                row.OrderWaitOutQuantity +
                                '）  库存(' +
                                (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                '）'
                                " placement="top">
                                <span :class="{
                                    'color-red':
                                        (submitData.WarehouseId ? row.StorageInventory : row.Inventory) +
                                        (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                        row.OrderWaitOutQuantity <=
                                        0
                                }">
                                    {{ (submitData.WarehouseId ? row.StorageInventory : row.Inventory) + (isAddWaitIn ? row.POrderWaitInQuantity : 0) -
                                        row.OrderWaitOutQuantity }}
                                </span>
                            </el-tooltip>
                        </div>
                    </template>
                </ux-table-column>
                <ux-table-column field="bz" title="备注" width="180" :edit-render="{ autofocus: '.el-input__inner' }" resizable>
                    <template v-slot="{ row }">
                        <div class="div-padding-12">{{ row.Remark }}</div>
                    </template>
                    <template v-slot:edit="scope">
                        <el-input ref="remarkRef" class="remark-input-cell" size="small" v-model="scope.row.Remark" :disabled="type == 1"
                            @keyup.enter.native="addItem(true)" @keyup.left.native="keyEvent($event, 'Remark')"></el-input>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" width="120">
                    <template v-slot="{ row, rowIndex }">
                        <div class="operate" v-if="type != 1">
                            <el-button size="small" @click="delItem(rowIndex)" icon="el-icon-delete" v-if="dataList.length !== 1"></el-button>
                            <el-button size="small" type="primary" @click="addItem(true)" icon="el-icon-plus" v-if="rowIndex + 1 === dataList.length"></el-button>
                            <el-button size="small" @click="upLock(rowIndex)" :icon="row.hasLock ? 'el-icon-lock' : 'el-icon-unlock'"
                                v-if="isLock && lastRowIndex !== rowIndex"></el-button>
                        </div>
                    </template>
                </ux-table-column>
            </ux-grid>
        </div>
        <!--    新增供应商    -->
        <el-dialog :close-on-click-modal="false" :title="customerEditType == 2 ? '编辑供应商' : '新增供应商'" :visible.sync="dialogCusVisible" width="1000px">
            <div class="dialog-content" v-if="dialogCusVisible">
                <customerEdit ref="customerEdit" :cusId="submitData.EntpCusId" :type="customerEditType" source="2" @closeDialog="closeDialog"></customerEdit>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="apMsgVisible" width="1000px">
            <div v-if="apMsgVisible">
                <APMsg :dialogFormVisible="apMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--    采购历史    -->
        <el-dialog  v-dialog-drag :modal="false" :close-on-click-modal="false" title="采购历史" append-to-body  :visible.sync="historyPurVisible" width="1200px" style="margin-left: -500px" id="change-dialog">
            <div v-if="historyPurVisible">
                <APPurchaseHistory ref="APPurchaseHistory" :EntpTempGoodsId="goodsId" :EntpCusId="submitData.EntpCusId" :EntpCusName="submitData.EntpCusName" :Source="1"
                    @closeDialog="closePurHistoryDialog"></APPurchaseHistory>
            </div>
        </el-dialog>
        <!-- 销售历史 -->
        <el-dialog title="销售历史" v-dialog-drag :modal="false" :close-on-click-modal="false" :visible.sync="historySalesVisible" append-to-body width="1200px" style="margin-left: -500px" id="change-dialog">
            <div v-if="historySalesVisible">
                <APHistory ref="APHistory" :showCusColumn="false" :EntpTempGoodsId="goodsId" @closeDialog="historySalesVisible = false"></APHistory>
            </div>
        </el-dialog>
        <!--    报价历史    -->
        <el-dialog :close-on-click-modal="false" title="报价历史" :visible.sync="historyQuoteVisible" width="1200px">
            <div v-if="historyQuoteVisible">
                <APQuoteHistory :EntpCusId="submitData.EntpCusId" :EntpTempGoodsId="goodsId" :EntpCusName="submitData.EntpCusName"
                    @closeDialog="closeHistoryDialog"></APQuoteHistory>
            </div>
        </el-dialog>
        <!--询价历史-->
        <el-dialog :close-on-click-modal="false" title="询价历史" :visible.sync="inqHistoryVisible" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="change-dialog" style="margin-left: -500px" width="1200px">
            <div v-if="inqHistoryVisible">
                <APInquiryHistory ref="APInquiryHistory" :EntpTempGoodsId="goodsId" :EntpCusId="type == 8 ? submitData.EntpCusId : ''" @closeDialog="() => {
                    inqHistoryVisible = false;
                }
                    "></APInquiryHistory>
            </div>
        </el-dialog>
        <!--在订历史-->
        <el-dialog :close-on-click-modal="false" title="在订历史" :visible.sync="intenHistoryVisible" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="change-dialog" style="margin-left: -500px" width="1200px">
            <div v-if="intenHistoryVisible">
                <APIntenHistory ref="APIntenHistory" :EntpTempGoodsId="goodsId" :EntpCusId="submitData.EntpCusId" :EntpCusName="submitData.EntpCusName" @closeDialog="() => {
                    intenHistoryVisible = false;
                }
                    "></APIntenHistory>
            </div>
        </el-dialog>
        <!-- 数据分析 -->
        <el-dialog :close-on-click-modal="false" title="商品销售采购数据图表" :visible.sync="goodsAnalysisVisible" width="1200px">
            <div class="dialog-content" v-if="goodsAnalysisVisible">
                <goodsAnalysis :GoodsId="goodsId" @closeDialog="goodsAnalysisVisible = false"></goodsAnalysis>
            </div>
        </el-dialog>
        <el-dialog :title="NeedITitle" :close-on-click-modal="false" :visible.sync="needInDataVisible" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="change-dialog" style="margin-left: -500px" width="900px">
            <div v-if="needInDataVisible">
                <APNeedInDatas ref="APNeedInDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needInDataVisible = false"></APNeedInDatas>
            </div>
        </el-dialog>
        <el-dialog :title="NeedOTitle" :close-on-click-modal="false" :visible.sync="needOutDataVisible" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="change-dialog" style="margin-left: -500px" width="900px">
            <div v-if="needOutDataVisible">
                <APNeedOutDatas ref="APNeedOutDatas" :EntpTempGoodsId="EntpTempGoodsId" @closeDialog="needOutDataVisible = false"></APNeedOutDatas>
            </div>
        </el-dialog>
        <!-- 进度条 -->
        <el-progress v-if="searchApParams._visible" class="saveProgress" type="circle" :percentage="searchApParams._percentage" />
        <!-- 新增库存 -->
        <transInventory v-if="addAPVisible" :dialogFormVisible="addAPVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></transInventory>
        <!-- 配件搜索条件弹窗 -->
        <el-dialog :close-on-click-modal="false" title="配件搜索" :visible.sync="searchVisible" width="435px" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="search-dc-dialog" custom-class="search-item-dialog" style="margin-left: -170px" @close="closeSearchDialog">
            <div class="dialog-content" v-if="searchVisible">
                <el-form ref="form" label-position="left" label-width="82px">
                    <el-form-item label="联合搜索">
                        <el-input ref="search_0" style="width: 100%" size="small" clearable v-model="searchData.JointSearch"
                            :placeholder="'用分隔符“' + (separator == ' ' ? '空格' : separator) + '”隔开'" @focus="selectAutoHandle('search_0')"></el-input>
                    </el-form-item>
                    <el-form-item label="配件编码" v-if="isExObj('APCode')">
                        <el-autocomplete ref="search_1" size="small" style="width: 100%" v-model="searchData.APCode" :fetch-suggestions="searchAPCode"
                            :debounce="500" placeholder="请输入配件编码" :trigger-on-focus="false" @select="stopSearch" v-scrollLoad="searchAPCodeLoad"></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="配件名称" v-if="isExObj('GoodName')">
                        <el-autocomplete ref="search_2" size="small" style="width: 100%" v-model="searchData.GoodName" :fetch-suggestions="searchGoodName"
                            :debounce="500" placeholder="请输入配件名称" :trigger-on-focus="false" @select="stopSearch"
                            v-scrollLoad="searchGoodNameLoad"></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="适用车型" v-if="isExObj('AutoSerise')">
                        <el-autocomplete ref="search_3" size="small" style="width: 100%" :debounce="500" v-model="searchData.AutoSerise"
                            :fetch-suggestions="searchAutoSerise" placeholder="请输入车型" :trigger-on-focus="false" @select="stopSearch"
                            v-scrollLoad="searchAutoSeriseLoad"></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="互换码" v-if="isExObj('GoodCode')">
                        <el-input ref="search_4" style="width: 100%" size="small" v-model="searchData.GoodCode" placeholder="请输入互换码"
                            @focus="selectAutoHandle('search_4')"></el-input>
                    </el-form-item>
                    <el-form-item label="汽配分类" v-if="isExObj('Cate')">
                        <el-select ref="search_5" size="small" style="width: 100%" v-model="searchData.Cate" multiple collapse-tags filterable clearable
                            @visible-change="getGoodsType($event)">
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="汽配品牌" v-if="isExObj('Brand')">
                        <el-select ref="search_6" v-model="searchData.BrandName" multiple collapse-tags filterable clearable size="small" style="width: 100%"
                            @visible-change="getGoodsBrand($event)">
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="库存数" v-if="isExObj('Inventory')">
                        <div class="flex">
                            <el-select size="small" style="width: 90px" v-model="searchData.Symbol" clearable placeholder="符号">
                                <el-option key=">=" label=">=" value=">="></el-option>
                                <el-option key=">" label=">" value=">"></el-option>
                                <el-option key="<=" label="<=" value="<="></el-option>
                                <el-option key="<" label="<" value="<"></el-option>
                                <el-option key="=" label="=" value="="></el-option>
                                <el-option key="!=" label="!=" value="!="></el-option>
                                <el-option key="between" label="区间" value="between"></el-option>
                            </el-select>
                            <el-input ref="search_7" size="small" style="width: 90px" v-model.trim="searchData.Invent1"
                                @focus="selectAutoHandle('search_7')"></el-input>
                            <el-input size="small" style="width: 90px" v-model.trim="searchData.Invent2" v-if="searchData.Symbol == 'between'"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="尺寸" v-if="isExObj('Size')">
                        <el-input ref="search_8" style="width: 100%" size="small" v-model="searchData.Size" placeholder="请输入尺寸"
                            @focus="selectAutoHandle('search_8')"></el-input>
                    </el-form-item>
                    <el-form-item label="产地" v-if="isExObj('Origin')">
                        <el-autocomplete ref="search_9" size="small" style="width: 100%" v-model="searchData.Origin" :fetch-suggestions="searchOrigin"
                            :debounce="500" placeholder="请输入产地信息" :trigger-on-focus="false" @select="stopSearch" v-scrollLoad="searchOriginLoad"></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="自定义属性" v-if="isExObj('GoodDesc')">
                        <el-input ref="search_10" style="width: 100%" size="small" v-model="searchData.GoodDesc" placeholder="请输入属性值"
                            @focus="selectAutoHandle('search_10')"></el-input>
                    </el-form-item>
                    <el-form-item label="销售时间" v-if="isExObj('SalesOutWHCout')">
                        <el-date-picker v-model="dateTimes" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" :picker-options="pickerOptions" @change="sdthandleChange" :default-time="['00:00:00', '23:59:59']"
                            format="yyyy-MM-dd HH:mm" size="small" style="width: 100%"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="查询公式">
                        <el-radio-group v-model="searchData.SearchType">
                            <el-radio :label="0">左等</el-radio>
                            <el-radio :label="1">全等</el-radio>
                            <el-radio :label="2">包含</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button size="small" type="primary" @click="jointSets">设置查询条件</el-button>
                    <el-button size="small" @click="resetSearch">重置</el-button>
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                </div>
            </div>
        </el-dialog>
        <!-- 加入清单 -->
        <el-dialog :close-on-click-modal="false" title="加入清单" width="400px" :visible.sync="rowVisible" append-to-body v-dialog-drag lock-scroll :modal="false"
            id="comfirm-ap-dialog" custom-class="search-item-dialog" style="margin-left: -170px">
            <div class="dialog-content" v-if="rowVisible" v-loading="rowFormLoading">
                <el-form label-position="left" label-width="70px" :model="rowForm">
                    <el-form-item label="汽配编码">
                        <el-input v-model="rowForm.APCode" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="配件名称">
                        <el-input v-model="rowForm.GoodName" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="车型">
                        <el-input v-model="rowForm.AutoSerise" disabled size="small" />
                    </el-form-item>
                    <el-form-item label="数量">
                        <el-input :min="1" @input="change($event)" ref="confirm_0" key="confirm_0" v-model="rowForm._count" size="small" style="width: 100%"
                            @focus="selectAutoHandle('confirm_0')" type="number" />
                    </el-form-item>
                    <el-form-item label="价格">
                        <el-input :min="0" @input="change($event)" ref="confirm_1" v-model="rowForm._price" size="small" style="width: 100%"
                            @focus="selectAutoHandle('confirm_1')" type="number" />
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input @focus="selectAutoHandle('confirm_2')" ref="confirm_2" v-model="rowForm.Remark" size="small" />
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button class="btn-primary" size="small" :disabled="rowFormLoading" @click="rowConfirm">加入清单(Enter)</el-button>
                <el-button size="small" :disabled="rowFormLoading" @click="rowClose">取消(ESC)</el-button>
            </div>
        </el-dialog>
        <!-- 自定义列 -->
        <el-dialog :close-on-click-modal="false" title="自定义列展示设置" @close="closeDialog" :visible.sync="tableSetsVisible" append-to-body width="600px">
            <div class="dialog-content" v-if="tableSetsVisible">
                <tableSets :tableCode="tableCode" @closeDialog="closeDialog"></tableSets>
            </div>
        </el-dialog>
        <!-- 条件设置 -->
        <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeJointDialog" :visible.sync="jointSetVisible" append-to-body width="400px">
            <div class="dialog-content" v-if="jointSetVisible">
                <jointSets @closeDialog="closeJointDialog"></jointSets>
            </div>
        </el-dialog>
        <!--   配件信息     -->
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="apAutoMsgVisible" width="1380px">
            <div v-if="apAutoMsgVisible">
                <APAutoMsg :dialogFormVisible="apAutoMsgVisible" :EntpTempGoodsId="goodsId" @closeDialog="closeAPMsgDialog"></APAutoMsg>
            </div>
        </el-dialog>
        <!-- 新增库存 - 包含车型选择 -->
        <addGoods v-if="addAPAutoVisible" :dialogFormVisible="addAPAutoVisible" :apParams="addAPParams" @closeDialog="closeAddAPDialog"></addGoods>
    </div>
</template>
<script>
import customerEdit from '@/components/business/customerManage/customerEdit';
import APMsg from '@/components/common/APMsgIntenVs';
import mixin from '@/mixins/mixin';
import APHistory from '@/components/common/ARSaleHistory';
import APPurchaseHistory from '@/components/common/ARPurchaseHistory';
import APQuoteHistory from '@/components/common/APQuoteHistory';
import APInquiryHistory from '@/components/common/APInquiryHistory_V2';
import APIntenHistory from '@/components/common/APIntenHistory';
import goodsAnalysis from '@/components/common/goodsAnalysis';
import transInventory from '@/components/business/search/transInventory';
import tableSets from '@/components/common/tableSets_v2.vue';
import jointSets from '@/components/common/jointSets.vue';
import APNeedInDatas from '@/components/common/APNeedInDatas';
import APNeedOutDatas from '@/components/common/APNeedOutDatas';
import APAutoMsg from '@/components/common/APAutoMsgIntenVs';
import addGoods from '@/components/business/search/addGoods';

export default {
    mixins: [mixin],
    name: '',
    components: {
        customerEdit,
        APMsg,
        APHistory,
        APPurchaseHistory,
        APQuoteHistory,
        APInquiryHistory,
        APIntenHistory,
        goodsAnalysis,
        transInventory,
        tableSets,
        jointSets,
        APNeedInDatas,
        APNeedOutDatas,
        addGoods,
        APAutoMsg
    },
    data() {
        return {
            canRequest: true,
            isCheckCode: true,
            isCanTBSet: false,
            submitStorageName: 'purxjOrder',
            dataStorageName: 'purxjOrder_dataList',
            confirmIndex: 0,
            searchIndex: 0,
            currentRow: {},
            dataindex: 0,
            tableCode: 'SearchAPForInq',
            isStartSearch: false,
            isStartConfirm: false,
            historySalesVisible: false,
            historyQuoteVisible: false,
            historyPurVisible: false,
            inqHistoryVisible: false,
            intenHistoryVisible:false,
            goodsId: '',
            customerEditType: 1,
            needConfirm: true,
            dialogCusVisible: false,
            apMsgVisible: false,
            searchVisible: false,
            jointSetVisible: false,
            needInDataVisible: false,
            needOutDataVisible: false,
            NeedITitle: '',
            NeedOTitle: '',
            priceCanBeZero: false,
            addressDialogVisible: false,
            goodsAnalysisVisible: false,
            showOrderMsg: true,
            showResultMsg: false,
            dataReadonly: false,
            rowVisible: false,
            rowForm: {},
            allNum: 0,
            allMoney: 0,
            loading: false,
            searchLoading: false,
            canNotEditAddr: false,
            priceCanBeEdit: false,
            isSalePriceShow: false,
            SIdList: [],
            submitData: {
                InquiryId: '',
                EntpCusId: '',
                NeedTime: '',
                Remark: '',
                ITime: '',
                QTime: '',
                PriceSumShip: '',
                IsSubmitReview: false,
                WarehouseId: '',
                DetailList: [],
                OId: '' // 采购退货单id，转询价使用
            },
            Limit: 10,
            customerList: [],
            typeList: [],
            brandList: [],
            codeList: [],
            dataList: [],
            unitList: [],
            type: 1, //1 查看 2 编辑 3 新增 4 从库存配件管理过来的
            id: '',
            pageTitle: '',
            rules: {
                EntpCusId: [
                    {
                        required: true,
                        message: '填选择供应商',
                        trigger: 'blur'
                    }
                ]
            },
            permission: {},
            warehouseList: [], //仓库地址
            changeCodeConfig: false,
            infiniteListHeight: 0, // 列表高度，在收起信息栏时进行实时计算
            selectedData: [],
            apcodeSource: null, // 用于处理取消编码请求操作
            // 是否预先加载汽配编码列表数据
            isPreloadApCodeList: false,
            // 用于供应商列表，分页搜索功能
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 用于汽配编码列表，分页搜索功能
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            // 加锁：选择商品完成回车或点加号后触发锁定不可修改
            hasLock: false,
            // 汽配编码排序标识
            sortActive: '',
            // 搜索配件弹框返回参数
            searchApParams: {
                _visible: false,
                _percentage: 0,
                _limit: 500,
                // 总数量
                _totalCount: 0
            },
            // 功能配置项：初始数量值 - 改功能暂时注释 2021-7-23
            initNumber: 1,
            //留余是否计算待入数据
            //否：留余数=库存数-待出库数
            //是：留余数=库存数-待出库数+待入库数
            isAddWaitIn: true,
            // 新增库存
            addAPVisible: false,
            addAPParams: {},
            isInvenShow: false,
            isOrgShow: false, //开单部门
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            orgList: [],
            tableData: [],
            tableDataLength: 0,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '1',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                InStartDate: '',
                InEndDate: '',
                CusSources: '',
                CusSourcesName: '',
            },
            columnShowSets: [],
            tableSetsVisible: false,
            separator: '',
            dateTimes: '',
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            scrollTop: 0,
            scrollLeft: 0,
            timer: null, //保存setTimeout定时器对象
            optionLoading: false,
            goodNameOptions: [],
            goodNameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            apCodeOptions: [],
            apCodeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            originOptions: [],
            originForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            canSearch: true,
            rowFormLoading: false,
            isShowSummary: false,
            summaryList: [],
            isOriginSort: false,
            nameCallBack: '',
            apCodeCallBack: '',
            originCallBack: '',
            autoCallBack: '',
            isUseSE: false,
            isShowBrand: false,//是否显示品牌
            startAddChace: false,
            discountOptions: [
                {
                    id: 0,
                    value: '无优惠'
                },
                {
                    id: 1,
                    value: '优惠金额'
                },
                {
                    id: 2,
                    value: '整单优惠'
                }
            ],
            isAutoDialog: false,//配件弹窗具备车型功能
            addAPAutoVisible: false,
            apAutoMsgVisible: false,
            cusSourcesList: [],
            isUseSource: false,
            hisGoodsId:''
        };
    },
    watch: {
        $route(to, from) {
            if (to === this.$route) {
                this.init();
                this.submitData = {};
                this.allMoney = 0;
                this.allNum = 0;
                this.dataList = [];
            }
        },
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_0.focus();
                    this.searchIndex = 0;
                });
            }
        },
        isStartConfirm(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.confirm_0.focus();
                    this.confirmIndex = 0;
                });
            }
        },
        dataList: {
            handler(newVal, oldVal) {
                if (Number(this.type) != 1 && this.startAddChace)
                    this.addPageChace();
            },
            deep: true,
        },
        submitData: {
            handler(newVal, oldVal) {
                if (Number(this.type) != 1 && this.startAddChace)
                    this.addPageChace();
            },
            deep: true,
        },
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
        this.getConfigByCodes();
        if (this.tableCode) {
            this.getSetsData();
            this.getJointSearchSets();
        }
    },
    mounted() {
        this.init();
        //当表格出现滚动条后，编辑最后一条数据时，点击滚动条内底部的空白处单元格的编辑状态没有去除
        //为了解决这个bug在表格的父级监听点击事件来清除单元格激活状态
        let tablebody = document.querySelector('.elx-table--body-wrapper');
        tablebody.addEventListener('click', this.clearActived, false);
    },
    computed: {
        // 是否加锁
        isLock() {
            return this.hasLock && [2, 3, 7, 8].includes(this.type * 1);
        },
        // 列表数据最后一行下标
        lastRowIndex() {
            return Array.isArray(this.dataList) ? this.dataList.length - 1 : 0;
        },
        // 是否展示：清空商品数量为0按钮
        showInitNumberBtn() {
            return this.initNumber == 0 && ![1, 4, 5, 6].includes(this.type * 1);
        },
        noFee() {
            return this.submitData.ShipAmount && this.submitData.ShipAmount * 1 !== 0;
        },
        // 优惠后的金额
        discountCount() {
            let discountCount = this.submitData.DiscountAmount;
            let shipAmount = this.submitData.ShipAmount ? this.submitData.ShipAmount * 1 : 0;

            if (this.submitData.DiscountType === 2) {
                // 处理整单优惠
                discountCount = (this.submitData.DiscountRate / 100) * this.allMoney;
            }
            if (!discountCount || this.submitData.DiscountType === 0) {
                return (this.allMoney * 1 + shipAmount).toFixed(2);
            }
            return (this.allMoney * 1 - discountCount + shipAmount > 0 ? this.allMoney * 1 - discountCount + shipAmount : 0).toFixed(2);
        },
    },
    filters: {
        AutoSeriseTextSplit(x) {
            if (~x.indexOf(',')) {
                return x.split(',').join('<br/>');
            } else {
                return x;
            }
        }
    },
    directives: {
        //用户选择栏的懒加载
        scrollLoad: {
            bind(el, binding, vnode) {
                //防抖函数
                function debounce(func, wait, immediate) {
                    //func函数，wait为时间周期
                    var timeout;
                    return function () {
                        var context = this,
                            args = arguments;
                        var later = function () {
                            timeout = null;
                            if (!immediate) {
                                func.apply(context, args);
                            }
                        };
                        var callNow = immediate && !timeout;
                        clearTimeout(timeout);
                        timeout = setTimeout(later, wait);
                        if (callNow) {
                            func.apply(context, args);
                        }
                    };
                }
                let wrapDom = el.querySelector('.el-autocomplete-suggestion__wrap');
                let listDom = el.querySelector('.el-autocomplete-suggestion__wrap  .el-autocomplete-suggestion__list');
                //将滚动事件通过参数传入防抖函数中
                var myEfficientFn = debounce(function () {
                    let condition = wrapDom.offsetHeight + wrapDom.scrollTop + 10 - listDom.offsetHeight;
                    if (condition > 0 && !vnode.context.loading) {
                        //滚动到底部则执行滚动方法load，binding.value就是v-scrollLoad绑定的值，加()表示执行绑定的方法
                        binding.value();
                    }
                }, 250);
                wrapDom.addEventListener('scroll', myEfficientFn, false); //绑定滚动事件
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            if (that.dataReadonly) return;
            let key = window.event.keyCode;
            if (key === 107) {
                //+
                if (!that.searchVisible) that.addItem(false);
                return;
            }
            if (key == 112) {
                //F1
                e.preventDefault();
                that.goback();
                return;
            }
            if (key == 113) {
                //F2
                e.preventDefault();
                if (that.type == 4) return;
                //在订转采购的限制
                if (this.type == 8 && !this.submitData.EntpCusId) {
                    this.$util.warningMsg('请先选供应商');
                    return;
                }
                if (!that.searchVisible) {
                    that.resetSearch();
                    that.searchVisible = true;
                    that.hideMsg();
                    that.showResultFunc();
                    if (that.rowVisible) {
                        that.isStartConfirm = false;
                        that.rowVisible = false;
                    }
                }
                that.isStartSearch = true;
                return;
            }
            if (key == 114) {
                //F3
                if (that.type == 4) return;
                e.preventDefault();
                that.showAPMsgDialog();
                return;
            }
            if (key == 115) {
                //F4
                if (that.type == 4) return;
                e.preventDefault();
                if (!that.goodsAnalysisVisible) that.analysis();
                return;
            }
            if (key == 116) {
                //F5
                if (that.type == 4) return;
                e.preventDefault();
                if (!that.historySalesVisible) that.showSalesHistories();
                return;
            }
            if (key == 117) {
                //F6
                if (that.type == 4) return;
                e.preventDefault();
                if (!that.historyPurVisible) that.showPurHistories();
                return;
            }
            if (key == 118) {
                //F7
                e.preventDefault();
                if (!that.inqHistoryVisible) that.showIntentDatas();
                return;
            }
            if (key == 119) {
                //F8
                e.preventDefault();
                // if (that.submitData.LogisticId) that.lceHandle(2);
                return;
            }
            if (key == 120) {
                //F9
                if (that.type == 2 || that.type == 3) {
                    e.preventDefault();
                    that.addCustomer(1);
                }
                return;
            }
            if (key == 121) {
                //F10
                if (that.type == 2 || that.type == 3) {
                    e.preventDefault();
                    if (that.submitData.EntpCusId) that.addCustomer(2);
                }
                return;
            }
            if (key == 122) {
                e.preventDefault();
                //F11
                if (!(that.permission.submit && !that.dataReadonly)) return;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.inqHistoryVisible &&
                    !that.addAPVisible &&
                    !that.apAutoMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible
                ) {
                    that.submitForm();
                    return;
                }
                return;
            }
            if (key === 13) {
                e.preventDefault();
                //Enter
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.addAPVisible &&
                    !that.apAutoMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible
                ) {
                    if (!that.searchVisible && that.currentRow && that.currentRow.EntpTempGoodsId) {
                        if (!that.rowVisible) {
                            that.dblChooseAps(that.currentRow);
                            if (that.searchVisible) {
                                that.searchVisible = false;
                                that.isStartSearch = false;
                            }
                        } else {
                            if (!that.rowFormLoading) that.rowConfirm();
                        }
                    } else if (
                        that.searchVisible &&
                        !that.rowVisible &&
                        (!that.$refs.search_5 || (that.$refs.search_5 && !that.$refs.search_5.visible)) &&
                        (!that.$refs.search_6 || (that.$refs.search_6 && !that.$refs.search_6.visible)) &&
                        that.canSearch
                    )
                        that.handleSearch();
                    that.canSearch = true;
                }

                return;
            }
            if (key === 27) {
                e.preventDefault();
                that.canSearch = true;
                if (
                    (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) ||
                    (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) ||
                    (that.$refs.search_3 && that.$refs.search_3.suggestionVisible) ||
                    (that.$refs.search_9 && that.$refs.search_9.suggestionVisible)
                ) {
                    if (that.$refs.search_2 && that.$refs.search_2.suggestionVisible) that.$refs.search_2.suggestions = [];
                    if (that.$refs.search_1 && that.$refs.search_1.suggestionVisible) that.$refs.search_1.suggestions = [];
                    if (that.$refs.search_9 && that.$refs.search_9.suggestionVisible) that.$refs.search_9.suggestions = [];
                    if (that.$refs.search_3.suggestionVisible) that.$refs.search_3.suggestions = [];
                    return;
                }
                if (that.searchVisible && !that.rowVisible) {
                    that.searchVisible = false;
                    that.isStartSearch = false;
                } else if (!that.searchVisible && that.rowVisible) {
                    that.rowVisible = false;
                    that.isStartConfirm = false;
                }
                if (that.isAutoDialog) that.apAutoMsgVisible = false;
                else that.apMsgVisible = false;
                return;
            }
            //下键
            if (key == 40) {
                e.preventDefault();
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.goodsAnalysisVisible &&
                    !that.addAPVisible &&
                    !that.apAutoMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible
                ) {
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        var cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != that.tableDataLength - 1) {
                            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                                that.dataindex++;
                            } else that.dataindex = 0;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex + 4]);
                                    that.$refs.multipleTable.scrollToRow(that.$refs.multipleTable.data[index]);
                                    if(that.historySalesVisible) that.showSalesHistories();
                                    if(that.historyPurVisible) that.showPurHistories();
                                    if(that.inqHistoryVisible) that.showIntentDatas();
                                    if(that.intenHistoryVisible) that.showIntentCountDatas();
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                            if (that.dataindex > that.tableData.length - 10 && !that.searchLoading && that.dataindex < that.tableDataLength - 14) that.downKeyToLoad();
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 10) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }

                                that.searchIndex += 1;
                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex < 10) {
                                    that.searchIndex += 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 2) {
                            that.confirmIndex += 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
            //上键
            if (key == 38) {
                that.canSearch = true;
                if (
                    !that.dialogCusVisible &&
                    !that.historyVisible &&
                    !that.historyQuoteVisible &&
                    !that.addAPVisible &&
                    !that.apAutoMsgVisible &&
                    !that.addAPAutoVisible &&
                    !that.tableSetsVisible &&
                    !that.jointSetVisible &&
                    !that.apMsgVisible
                ) {
                    e.preventDefault();
                    if (!that.rowVisible && !that.searchVisible) {
                        //光标已经在编辑框内，不可上下移动
                        cursorFocus = document.querySelector('input:focus');
                        if (cursorFocus) {
                            e.preventDefault();
                            return;
                        }
                        if (that.dataindex != 0) {
                            that.dataindex--;
                            let index = that.dataindex;
                            that.$nextTick(() => {
                                if (that.$refs.multipleTable) {
                                    that.currentRow = that.$refs.multipleTable.data[index];
                                    that.$refs.multipleTable.setCurrentRow(that.$refs.multipleTable.data[index]);
                                    that.$refs.multipleTable.scrollToRow(that.tableData[that.dataindex - 5]);
                                    if(that.historySalesVisible) that.showSalesHistories();
                                    if(that.historyPurVisible) that.showPurHistories();
                                    if(that.inqHistoryVisible) that.showIntentDatas();
                                    if(that.intenHistoryVisible) that.showIntentCountDatas();
                                    that.getInvenDatas(that.currentRow);
                                }
                            });
                        }
                    } else if (!that.rowVisible && that.searchVisible) {
                        if (that.searchIndex != 0) {
                            if (
                                (!that.$refs.search_5 || !that.$refs.search_5.visible) &&
                                (!that.$refs.search_6 || !that.$refs.search_6.visible) &&
                                (!that.$refs.search_1 || !that.$refs.search_1.suggestionVisible) &&
                                (!that.$refs.search_9 || !that.$refs.search_9.suggestionVisible) &&
                                (!that.$refs.search_2 || !that.$refs.search_2.suggestionVisible) &&
                                (!that.$refs.search_3 || !that.$refs.search_3.suggestionVisible)
                            ) {
                                if (that.searchIndex == 5 || that.searchIndex == 6) {
                                    if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].blur();
                                }

                                that.searchIndex -= 1;
                                while (!that.$refs[`search_` + that.searchIndex] && that.searchIndex > 0) {
                                    that.searchIndex -= 1;
                                }

                                if (that.$refs[`search_` + that.searchIndex]) that.$refs[`search_` + that.searchIndex].focus();
                            }
                        }
                    } else if (that.rowVisible && !that.searchVisible) {
                        if (that.confirmIndex != 0) {
                            that.confirmIndex -= 1;
                            if (that.$refs[`confirm_` + that.confirmIndex]) that.$refs[`confirm_` + that.confirmIndex].focus();
                        }
                    }
                    return;
                }
                return;
            }
        },
        goback() {
            this.$router.push('/purchaseManage/inquirySheet');
        },
        getConfigByCodes() {
            let codes = ['ddhhm', 'kdyjz', 'kdbjsd', 'spmrsl', 'lybsdr', 'ddkcs', 'kdspcd', 'kdspgg', 'kdxspp', 'xzqpbmdwyx', 'ygsfkzdylb', 'tstjqpauto','kcspssyq'];
            this.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        let rValue = data[i].RValue;
                        switch (code) {
                            case 'ddhhm': //是否展示互换码
                                this.changeCodeConfig = result;
                                break;
                            case 'kdyjz': // 获取预加载商品数据的功能设置结果
                                this.isPreloadApCodeList = result;
                                break;
                            case 'kdbjsd': // 选择商品完成回车或点加号后触发锁定不可修改
                                this.hasLock = result;
                                break;
                            case 'spmrsl': // 获取客户配置的初始数量值
                                if (result && !isNaN(rValue)) this.initNumber = rValue;
                                if (this.dataList && this.dataList.length > 0) {
                                    let lastData = this.dataList[this.dataList.length - 1];
                                    if (!lastData.EntpTempGoodsId) {
                                        lastData.Count = this.initNumber;
                                    }
                                }
                                break;
                            case 'lybsdr': //获取留余的计算方式
                                this.isAddWaitIn = !result;
                                break;
                            case 'ddkcs':
                                this.isInvenShow = result;
                                break;
                            case 'kdspcd': //是否出现产地
                                this.isOriginShow = result;
                                break;
                            case 'kdspgg': //是否出现规格
                                this.isSizeShow = result;
                                break;
                            case 'kdxspp': //是否显示品牌
                                this.isShowBrand = result;
                                break;
                            case 'xzqpbmdwyx': //是否检测编码重复
                                this.isCheckCode = result;
                                break;
                            case 'ygsfkzdylb': //是否可自定义列表
                                this.isCanTBSet = result;
                                break;
                            case 'tstjqpauto': //配件弹窗展示车型
                                this.isAutoDialog = result;
                                break;
                                case 'kcspssyq': //使用搜索引擎
                                    this.isUseSE = result;
                                    break;
                        }
                    }
                }
            });
        },
        init() {
            this.permission = this.$util.getPermission('supplierRFQ');
            this.id = this.$route.query.id;
            this.submitData.InquiryId = this.$route.query.id;
            this.type = this.$route.query.type;
            let purxjOrder = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (this.type == 1) {
                this.dataReadonly = true;
                this.pageTitle = '查看询价单';
                this.getBJOrder();

            } else if (this.type == 2) {
                this.pageTitle = '编辑询价单';
                if (purxjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getBJOrder();
                }
            } else if (this.type == 3) {
                this.pageTitle = '新增询价单';
                if (purxjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.getdefaultWarehouses();
                }
            } else if (this.type == 4) {
                this.pageTitle = '再次询价单'; //采购转询价
                if (purxjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.bjAgain();
                }
            } else if (this.type == 6) {
                this.pageTitle = '采购退货转询价';
                if (purxjOrder && datalist && datalist.length > 0) {
                    this.getDataFromChace();
                } else {
                    this.submitData.OId = this.$route.query.rid;
                    this.getPurRetrunOrder();
                }
            }
        },
        showAddAPDialog() {
            if (this.isAutoDialog) this.addAPAutoVisible = true;
            else this.addAPVisible = true;
        },
        // 关闭新增库存弹框
        async closeAddAPDialog(result, row) {
            let that = this;
            if (!row) {
                if (that.isAutoDialog) that.addAPAutoVisible = false;
                else that.addAPVisible = false;
                return;
            } else {
                //移除最后一个空的配件
                if (that.dataList.length > 0 && !that.dataList[that.dataList.length - 1].EntpTempGoodsId) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                }
                that.dataList.push({
                    ...row,
                    Count: this.initNumber,
                    // 是否可编辑，用于报价转销售情况时新增数据情况
                    canEdit: this.type != 1,
                    State: 0,
                    StorageInventory: 0,
                    OrderWaitOutQuantity: 0,
                    POrderWaitInQuantity: 0,
                    MarketPrice: row.CostPrice // 成本价赋值给采购价
                });
                if (that.isAutoDialog) that.addAPAutoVisible = false;
                else that.addAPVisible = false;
            }
            this.priceChange();
        },
        // 清空数量为零的Row
        resetZeroHandle() {
            this.dataList = this.dataList.filter(f => f.Count * 1 > 0);
            this.$util.successMsg('已清空商品数量为 0 的商品');
        },
        change(e) {
            let that = this;
            if (!that.rowVisible) {
                let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === that.currentRow.EntpTempGoodsId);
                if (fIdx > -1) {
                    that.dataList[fIdx].Count = that.rowForm._count;
                    that.dataList[fIdx].MarketPrice = that.rowForm._price;
                }
            }
        },
        // 编码排序
        changeTableSort(type, prop) {
            let sortArr = [];
            let listArr = this.dataList.filter(f => f[prop]);
            let otherArr = this.dataList.filter(f => !f[prop]);
            if (type === 'top') {
                this.sortActive = 'top';
                sortArr = listArr.sort((a, b) => a[prop].localeCompare(b[prop]));
            } else {
                this.sortActive = 'bottom';
                sortArr = listArr.sort((a, b) => b[prop].localeCompare(a[prop]));
            }
            this.dataList = [...sortArr, ...otherArr];
        },
        getConfigData() {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
            });
        },
        // 搜索
        showSearch() {
            if (this.type == 8 && !this.submitData.EntpCusId) {
                this.$util.warningMsg('请先选供应商');
                return;
            }
            this.resetSearch();
            this.searchVisible = true;
            this.isStartSearch = true;
            this.showResultFunc();
            this.hideMsg();
        },
        showResultFunc() {
            this.showResultMsg = true;
        },
        hideResultFunc() {
            this.showResultMsg = false;
        },
        hideMsg() {
            this.showOrderMsg = false;
            if (this.$refs.cusselect) this.$refs.cusselect.blur();
        },
        showMsg() {
            this.showOrderMsg = true;
        },
        // 配件信息
        showAPMsgDialog(id) {
            let that = this;
            if (!that.apMsgVisible && !that.isAutoDialog) {
                if (id) {
                    that.goodsId = id;
                    that.apMsgVisible = true;
                }
                else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                    that.goodsId = that.currentRow.EntpTempGoodsId;
                    that.apMsgVisible = true;
                }
            }
            else if (that.isAutoDialog && !that.apAutoMsgVisible) {
                if (id) {
                    that.goodsId = id;
                    that.apAutoMsgVisible = true;
                }
                else if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                    that.goodsId = that.currentRow.EntpTempGoodsId;
                    that.apAutoMsgVisible = true;
                }
            }
        },
        closeAPMsgDialog(edit) {
            if (this.isAutoDialog) this.apAutoMsgVisible = false;
            else this.apMsgVisible = false;
        },
        // 数量或者价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allNum = 0;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allNum += Number(DetailList[i].Count);
                _allMoney += Number(DetailList[i].Count * DetailList[i].MarketPrice ? (DetailList[i].Count * DetailList[i].MarketPrice).toFixed(3) : 0);
            }
            this.allMoney = _allMoney.toFixed(2);
            this.allNum = _allNum;
        },
        closeDialog(edit) {
            this.dialogCusVisible = false;
            this.tableSetsVisible = false;
            if (edit) {
                this.searchCustomer();
            }
        },
        addCustomer(type) {
            this.customerEditType = type;
            this.dialogCusVisible = true;
        },
        // 询价单转采购单详情
        getBJOrder() {
            this.getdefaultWarehouses();
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetEntpSupInquiryOrder',
                    data: {
                        InquiryId: this.id
                    }
                })
                .then(res => {
                    let data = res.data;
                    data.InquiryId = this.id;
                    this.customerList.push({
                        EntpCusId: data.EntpCusId,
                        EntpCusName: data.EntpCusName
                    });
                    this.submitData = data;
                    data.DetailList.forEach(ele => {
                        ele.hasLock = this.hasLock;
                    });
                    this.dataList = data.DetailList;
                    if (data.Warehouse) {//防止一个交互问题，这里和获取单据的设置仓库重合了，仓库选择下拉框会加载不出来
                        var isIn = this.warehouseList.find(x=>x.WarehouseId == data.Warehouse.WarehouseId);
                        if(!isIn){
                            this.warehouseList.push({
                                WarehouseId: data.Warehouse.WarehouseId,
                                WarehouseName: data.Warehouse.WarehouseName,
                                Type: data.Warehouse.WarehouseType
                            });
                        }
                        this.warehouseType = data.Warehouse.WarehouseType;
                        this.$set(this.submitData, 'WarehouseId', data.Warehouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseType', data.Warehouse.WarehouseType);
                        this.$set(this.submitData, 'WarehouseName', data.Warehouse.WarehouseName);
                    }
                });
        },
        // 提交询价单
        submitForm() {
            let _dataList = this.dataList;
            if (!this.submitData.EntpCusId) {
                this.$util.warningMsg('请选择供应商');
                return;
            }
            if (this.submitData.PriceSumShip < 0) {
                this.$util.warningMsg('运费不能小于0');
                return;
            }
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (_dataList[i].State != 0) {
                    this.$util.warningMsg('商品【' + _dataList[i].GoodName + '（' + _dataList[i].APCode + '）' + '】已删除');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (_dataList[i].MarketPrice == '' || Number(_dataList[i].MarketPrice) <= 0) {
                    this.$util.warningMsg('请填写正确的供应商报价');
                    return;
                }
            }
            this.submitData.DetailList = _dataList;
            if (!this.canRequest) {
                return;
            }
            let checkRepeat = this.checkRepeatAndReturnData();
            if (checkRepeat.hasRepeat) {
                this.$confirm('订单含有重复商品项，是否需要累加', '', {
                    type: 'error',
                    distinguishCancelAndClose: true
                })
                    .then(() => {
                        // 覆盖数据
                        this.dataList = checkRepeat.row;
                        this.submitData.DetailList = checkRepeat.row;
                        this.submitFormAgain();
                    })
                    .catch(() => { });
            } else {
                this.submitFormAgain();
            }
        },
        submitFormAgain() {
            this.canRequest = false;
            let url = '/api/EntpInquiryOrder/SaveEntpInquiryOrder';
            if (+this.type == 6) url = '/api/EntpInquiryOrder/TransformPurReturnOrder';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.submitData
                })
                .then(() => {
                    this.needConfirm = false;
                    this.$util.successMsg('提交询价单成功');
                    //编辑后列表页面需要刷新
                    this.$store.commit('updateNeedRefresh', true);
                    setTimeout(() => {
                        this.canRequest = true;
                        this.$router.push('/purchaseManage/inquirySheet');
                    }, 2000);
                })
                .catch(() => {
                    this.canRequest = true;
                });
        },
        // 检查是否有重复项及返回已合并数量的数据
        checkRepeatAndReturnData() {
            let [list, row, hasRepeat] = [this.submitData.DetailList, [], false];
            if (this.isCheckCode) {
                list.forEach(item => {
                    let index = row.findIndex(f => f.APCode === item.APCode);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            else {
                list.forEach(item => {
                    let index = row.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
                    if (index > -1) {
                        hasRepeat = true;
                        row[index].Count = Number(row[index].Count) + Number(item.Count);
                    } else {
                        row.push(Object.assign({}, item));
                    }
                });
            }
            return {
                hasRepeat,
                row
            };
        },
        // 删除某行
        delItem(index, item) {
            let that = this;
            if (that.dataList.length != 1) {
                that.dataList.splice(index, 1);
            }
            that.priceChange();

            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = false;
            }
        },
        // 添加一行
        addItem(addPageChace) {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (!_dataList[i].Count || Number(_dataList[i].Count) < 0) {
                    this.$util.warningMsg('请填写正确的配件数量');
                    return;
                }
                if (!_dataList[i].AutoSerise) {
                    this.$util.warningMsg('请填写车型');
                    return;
                }
                if (!_dataList[i].Unit) {
                    this.$util.warningMsg('请填写单位');
                    return;
                }
                if (!this.priceCanBeZero) {
                    if (!_dataList[i].MarketPrice || _dataList[i].MarketPrice < 0) {
                        this.$util.warningMsg('请填写正确的采购价');
                        return;
                    }
                }
            }
            // 上锁
            if (this.isLock) {
                this.dataList.forEach(ele => {
                    ele.hasLock = true;
                });
            }

            this.codeForm.key = '';
            this.codeForm.Page = 1;
            this.codeForm.Limit = 10;
            this.codeForm.stopLoad = false;

            this.dataList.push({
                EntpTempGoodsId: '',
                APCode: '',
                GoodName: '',
                GoodNameItem: '',
                AutoSerise: '',
                AutoSeriseItem: '',
                Count: this.initNumber,
                Price: '',
                SalePrice: '',
                Unit: '',
                Remark: '',
                CodeRepeat: false,
                WarehousedCount: 0,
                Inventory: 0, //商品总数量
                StorageInventory: 0, //仓库库存数量
                OrderWaitOutQuantity: 0,
                POrderWaitInQuantity: 0,
                State: 0,
                // 是否可编辑，用于报价转销售情况时新增数据情况
                canEdit: this.type != 1,
                Origin: '',
                Size: '',
                Brand: ''
            });

            setTimeout(() => {
                this.$refs.infiniteTable.scrollToRow(this.dataList[this.dataList.length - 1]);
                this.$refs.infiniteTable.setActiveRow(this.dataList[this.dataList.length - 1]);
                if (this.dataList.length > 1) {
                    let ilEle = document.getElementsByClassName('business-content')[0];
                    ilEle.scrollTop = ilEle.scrollHeight;
                }
            }, 100);

            this.priceChange();

            let that = this;
            that.$nextTick(() => {
                setTimeout(function () {
                    that.$refs.sapcode.focus();
                }, 200);
            });
        },
        // 解锁
        upLock(index) {
            this.$set(
                this.dataList,
                index,
                Object.assign({}, this.dataList[index], {
                    hasLock: !this.dataList[index].hasLock
                })
            );
        },
        // 点击展开下拉框
        focusHandle(isNew, index, type) {
            if (type === 'sapcode' && !isNew) {
                setTimeout(() => {
                    this.$refs[`sapcode`].focus();
                }, 200);
            }
            if (type === 'partsNameSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`partsNameSelect`].focus();
                }, 200);
            }
            if (type === 'autoSeriseSelect' && !isNew) {
                setTimeout(() => {
                    this.$refs[`autoSeriseSelect`].focus();
                }, 200);
            }
            if (type === 'originRef') {
                setTimeout(() => {
                    this.$refs[`originRef`].focus();
                }, 200);
            }
            if (type === 'countRef') {
                setTimeout(() => {
                    this.$refs[`countRef`].focus();
                }, 200);
            }
            if (type === 'unitSelect') {
                setTimeout(() => {
                    this.$refs[`unitSelect`].focus();
                }, 200);
            }
        },
        // 自动选中输入框内容
        selectAutoHandle(ref) {
            clearTimeout(this.timer);
            this.$nextTick(() => {
                this.timer = setTimeout(() => {
                    if (this.$refs[ref]) this.$refs[ref].select();
                },100);
            });
        },
        //判断是否有缓存,加载缓存或者请求订单信息
        loadStorage() {
            let transOrderModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (transOrderModel && datalist && datalist.length > 0) {
                return {
                    model: transOrderModel,
                    list: datalist
                };
            } else {
                return null;
            }
        },
        //添加页面缓存
        addPageChace() {
            this.removePageChace();
            this.$util.setLocalStorage(this.submitStorageName, this.submitData);
            this.$util.setLocalStorage(this.dataStorageName, this.dataList);
        },
        //清除页面缓存
        removePageChace() {
            this.$util.clearLocalStorage(this.submitStorageName);
            this.$util.clearLocalStorage(this.dataStorageName);
        },
        //从缓存中读取数据
        getDataFromChace() {
            let xjModel = this.$util.getLocalStorage(this.submitStorageName);
            let datalist = this.$util.getLocalStorage(this.dataStorageName);
            if (xjModel) {
                this.submitData = xjModel;
                let isexit = this.customerList.find(e => e.EntpCusId == xjModel.EntpCusId);
                if (!isexit) {
                    this.customerList.push({
                        EntpCusId: xjModel.EntpCusId,
                        EntpCusName: xjModel.EntpCusName
                    });
                }
            }
            if (xjModel.WarehouseId) {
                this.warehouseList.push({
                    WarehouseId: xjModel.WarehouseId,
                    WarehouseName: xjModel.WarehouseName,
                    Type: xjModel.WarehouseType
                });
                this.warehouseType = xjModel.WarehouseType;
                this.$set(this.submitData, 'WarehouseId', xjModel.WarehouseId);
                this.$set(this.submitData, 'WarehouseType', xjModel.WarehouseType);
                this.$set(this.submitData, 'WarehouseName', xjModel.WarehouseName);
            } else {
                this.getdefaultWarehouses();
            }
            this.dataList = datalist;
        },
        //从缓存中获取默认出仓仓库
        getdefaultWarehouses() {
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetLatestInquiryOrderWarehouse',
                    hideLoading: true
                })
                .then(res => {
                    let defaultWareshouse = res.data;
                    if (defaultWareshouse) { //防止一个交互问题，这里和获取单据的设置仓库重合了，仓库选择下拉框会加载不出来
                        var isIn = this.warehouseList.find(x=>x.WarehouseId == defaultWareshouse.WarehouseId);
                        if(!isIn){
                            this.warehouseList.push({
                                WarehouseId: defaultWareshouse.WarehouseId,
                                WarehouseName: defaultWareshouse.WarehouseName,
                                Address: defaultWareshouse.Address
                            });
                        }
                        this.$set(this.submitData, 'WarehouseId', defaultWareshouse.WarehouseId);
                        this.$set(this.submitData, 'WarehouseName', defaultWareshouse.WarehouseName);
                        this.$set(this.submitData, 'WarehouseAddr', defaultWareshouse.Address);
                        this.warehouseType = defaultWareshouse.WarehouseType;
                    }
                });
        },
        // 搜索供应商，分页
        searchCustomer(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.customerList = [];
            }
            if (this.supplierForm.stopLoad) return;
            this.loading = true;
            this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit).then(data => {
                this.loading = false;
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.customerList = this.$util.uniqueArr(this.customerList, data);
                //修改客户时要更新页面上展现的名称
                if (this.customerList.length > 0) {
                    let currCust = this.customerList.find(e => e.EntpCusId == this.submitData.EntpCusId);
                    if (currCust) {
                        this.submitData.EntpCusName = currCust.EntpCusName;
                    }
                }
            });
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchCustomer();
        },
        searchCode(key, item, index) {
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeForm.rowIndex = index;
                this.codeList = [];
            }
            if (item) {
                item.APCode = key;
            }
            if (this.codeForm.stopLoad) return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsSelItemsForPurchaseOrder',
                    data: {
                        APCode: this.codeForm.key,
                        Page: this.codeForm.Page,
                        Limit: this.codeForm.Limit
                    },
                    hideLoading: true
                })
                .then(res => {
                    let that = this;
                    this.loading = false;
                    if (!res.data) {
                        if (this.codeForm.Page == 1 && that.codeForm.key) {
                            let option = this.$refs[`sapcode`].options[0].$el;
                            if (option) {
                                option.onclick = function () {
                                    that.codeChange(that.codeForm.key, that.codeForm.rowIndex);
                                };
                            }
                        }
                        return;
                    }
                    this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                    this.codeList = this.$util.uniqueArr(this.codeList, res.data);

                    //ps 入过接口可以按条件的相似度来排序的化，下面的逻辑可以去除，比如查询条件为：1121时
                    that.$nextTick(() => {
                        if (that.codeForm.key) {
                            let hit = res.data.findIndex(c => c.APCode == that.codeForm.key);
                            if (hit != -1) {
                                hit = hit + (that.codeList.length - res.data.length);
                                let option = that.$refs[`sapcode`].options[hit].$el;
                                if (option) {
                                    option.onclick = function () {
                                        that.codeChange(that.codeForm.key, that.codeForm.rowIndex, option);
                                    };
                                }
                            }
                        }
                    });
                });
        },
        // 汽配编码列表，加载更多
        searchCodeLoad() {
            if (!this.loading) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 获取仓库列表
        getWarehouse() {
            this.$util.getWarehouse(1).then(data => {
                this.warehouseList = data;
            });
        },
        // 编码改变
        codeChange(value, index, option) {
            if (option) {
                option.onclick = function () { };
            }
            let isNew = true;
            let _list = this.codeList;
            if (!value) {
                this.dataList[index].IsNew = false;
            }
            for (let i = 0; i < _list.length; i++) {
                let checkItem = this.isCheckCode ? _list[i].APCode : _list[i].EntpTempGoodsId;
                if (checkItem == value) {
                    this.dataList[index].APCode = _list[i].APCode;
                    this.dataList[index].EntpTempGoodsId = _list[i].EntpTempGoodsId;
                    this.dataList[index].GoodName = _list[i].GoodName;
                    this.dataList[index].GoodNameItem = _list[i].GoodName;
                    this.dataList[index].MarketPrice = _list[i].CostPrice;
                    this.dataList[index].SalePrice = _list[i].MarketPrice;
                    this.dataList[index].Unit = _list[i].Unit;
                    this.dataList[index].Origin = _list[i].Origin;
                    this.dataList[index].AutoSerise = _list[i].AutoSerise;
                    this.dataList[index].AutoSeriseItem = _list[i].AutoSerise;
                    this.dataList[index].IsNew = false;
                    this.dataList[index].State = 0;
                    this.dataList[index].OrderWaitOutQuantity = _list[i].OrderWaitOutQuantity;
                    this.dataList[index].POrderWaitInQuantity = _list[i].POrderWaitInQuantity;
                    this.dataList[index].Inventory = _list[i].StorageInventory;
                    this.dataList[index].StorageInventory = _list[i].StorageInventory;
                    this.dataList[index].Size = _list[i].Size;
                    this.dataList[index].Brand = _list[i].Brand;
                    isNew = false;

                    this.$util.getGoodsDataAfterSelItem(this.dataList[index].EntpTempGoodsId, this.submitData.WarehouseId, this.submitData.EntpCusId, '2').then(data => {
                        if (data) {
                            this.dataList[index].OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            this.dataList[index].POrderWaitInQuantity = data.POrderWaitInQuantity;
                            this.dataList[index].StorageInventory = data.StorageInventory;
                            if (data.LatestPurPrice > 0) this.dataList[index].MarketPrice = data.LatestPurPrice;
                            this.dataList[index].IntenCount = data.IntenCount;
                        }
                    });
                    break;
                }
            }
            if (isNew && value && this.isCheckCode) {
                let that = this;
                this.$util.elConfirm({
                    content: '要创建一个新配件吗？',
                    noMsg: true,
                    confirm() {
                        that.dataList[index].EntpTempGoodsId = '';
                        that.dataList[index].Inventory = 0;
                        that.dataList[index].StorageInventory = 0;
                        that.dataList[index].MarketPrice = 0;
                        that.dataList[index].SalePrice = 0;
                        that.dataList[index].IsNew = true;
                        that.dataList[index].State = 0;
                        that.dataList[index].Origin = '';
                        that.dataList[index].Brand = '';
                        that.$refs.infiniteTable.setActiveRow(that.dataList[index]);
                        that.$util
                            .axiosGet({
                                url: '/api/EntpGoods/GetPart',
                                data: {
                                    APCode: value
                                },
                                hideLoading: true
                            })
                            .then(res => {
                                if (res.data) {
                                    let data = res.data;
                                    that.dataList[index].APCode = data.APCode;
                                    that.dataList[index].AutoSerise = data.AutoSerise;
                                    that.dataList[index].AutoSeriseItem = data.AutoSerise;
                                    that.dataList[index].GoodName = data.GoodName;
                                    that.dataList[index].GoodNameItem = data.GoodName;
                                    that.dataList[index].Unit = data.Unit;
                                } else {
                                    that.addAPParams = {
                                        APCode: that.dataList[index].APCode,
                                        index: index
                                    };
                                    that.addAPVisible = true;
                                    if (that.$refs[`sapcode`]) {
                                        that.$refs[`sapcode`].blur();
                                    }
                                }
                            });
                    }
                });
            } else {
                let inputAll = document.querySelectorAll('.purcounts-input-cell .el-input__inner');
                inputAll[0].focus();
            }
            this.priceChange();
        },
        // 供应商改变
        customerChange(value) {
            let that = this;
            if (!value) {
                that.submitData.EntpCusName = '';
            } else {
                let currCust = that.customerList.find(e => e.EntpCusId == value);
                if (currCust) {
                    that.submitData.EntpCusName = currCust.EntpCusName;
                }
            }
        },
        //单位下拉框显示时触发event
        unitVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.unitList.length == 0) that.getConfigData();
            }
        },
        //当供应商下拉框出现时触发
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.customerList.length <= 1) that.searchCustomer('');
            }
        },
        //当汽配件编码下拉框出现时触发
        apCodeVisibleChange(event) {
            let that = this;
            if (event && that.codeList.length == 0 && that.isPreloadApCodeList) {
                that.searchCode('');
            }
        },
        warehouseVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length <= 1) that.getWarehouse();
            }
        },
        warehouseChange(val) {
            let that = this;
            if (!val) {
                that.submitData.WarehouseName = '';
                that.dataList.forEach((e, i) => {
                    e.StorageInventory = 0;
                });
            } else {
                for (let i = 0; i < that.warehouseList.length; i++) {
                    if (val == that.warehouseList[i].WarehouseId) {
                        that.submitData.WarehouseAddr = that.warehouseList[i].Address;
                        that.submitData.WarehouseName = that.warehouseList[i].WarehouseName;

                        if (that.warehouseList[i].Type == 1) this.canNotEditAddr = true;
                        else this.canNotEditAddr = false;

                        break;
                    }
                }

                // 查询在这个仓库下的商品库存
                if (that.dataList) {
                    let ids = [];
                    that.dataList.forEach((e, i) => {
                        if (e.EntpTempGoodsId) ids.push(e.EntpTempGoodsId);
                    });
                    if (ids.length > 0) {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpSaleOrder/GetGoodsStoragesInventorys',
                                data: {
                                    sId: val,
                                    ids: ids
                                }
                            })
                            .then(res => {
                                let data = res.data;
                                that.dataList.forEach((e, i) => {
                                    let getStorage = data.find(d => d.GoodsId == e.EntpTempGoodsId);
                                    if (getStorage) {
                                        e.StorageInventory = getStorage.Count;
                                        e.OrderWaitOutQuantity = getStorage.OrderWaitOutQuantity;
                                        e.POrderWaitInQuantity = getStorage.POrderWaitInQuantity;
                                    } else {
                                        e.StorageInventory = 0;
                                        e.OrderWaitOutQuantity = 0;
                                        e.POrderWaitInQuantity = 0;
                                    }
                                });
                            })
                            .catch(() => { });
                    }
                }
            }
        },
        //采购历史
        showPurHistories() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                if(!that.historyPurVisible){
                    that.historyPurVisible = true;
                }else{
                    let gId = that.$refs.APPurchaseHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        that.$refs.APPurchaseHistory.updateTableData(this.goodsId);
                }
            }
        },
        // 采购历史
        showHistories(id) {
            let that = this;
            if (id) {
                this.goodsId = id;
                if(!that.historyPurVisible){
                    that.historyPurVisible = true;
                }else{
                    let gId = that.$refs.APPurchaseHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        that.$refs.APPurchaseHistory.updateTableData(this.goodsId);
                }
            }
        },
        closePurHistoryDialog() {
            this.historyPurVisible = false;
        },
        showSalesHistories(row) {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                if(!that.historySalesVisible){
                    that.historySalesVisible = true;
                }else{
                    let gId = that.$refs.APHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        that.$refs.APHistory.updateTableData(this.goodsId);
                }
            }
        },
        showSaleStat(row) {
            let that = this;
            if (row) {
                this.goodsId = row.EntpTempGoodsId;
                if(!that.historySalesVisible){
                    that.historySalesVisible = true;
                }else{
                    let gId = that.$refs.APHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        that.$refs.APHistory.updateTableData(this.goodsId);
                }
            }
        },
        analysis() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                this.goodsAnalysisVisible = true;
            }
        },
        // 设置展示行样式
        setRowStyle(param) {
            const { row, index } = param;
            let rowArr = [];
            if (this.isCheckCode)
                rowArr = this.dataList.filter(f => f.APCode === row.APCode);
            else
                rowArr = this.dataList.filter(f => f.EntpTempGoodsId === row.EntpTempGoodsId);
            if (rowArr.length > 1) {
                return `background-color: #FFE8E8`;
            }
        },
        //手动清除单元格激活状态
        clearActived(e) {
            if (e.target.className == 'elx-table--body-wrapper body--wrapper') {
                this.$refs.infiniteTable.clearActived();
            }
            e.stopPropagation();
            e.preventDefault();
        },
        keyEvent(ev, code, row, index) {
            let that = this;
            if (ev.key == 'ArrowLeft') {
                switch (code) {
                    case 'GoodName':
                        that.$refs[`sapcode`].focus();
                        break;
                    case 'AutoSerise':
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'Count':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`countRef`].focus();
                        break;
                    case 'MarketPrice':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Remark':
                        that.$refs[`marketPirceRef`].focus();
                        break;
                }
            } else if (ev.key == 'ArrowRight') {
                switch (code) {
                    case 'APCode':
                        if (that.$refs[`sapcode`]) that.$refs[`sapcode`].blur();
                        that.$refs[`partsNameSelect`].focus();
                        break;
                    case 'GoodName':
                        that.$refs[`autoSeriseSelect`].focus();
                        break;
                    case 'AutoSerise':
                        if (that.$refs[`originRef`]) that.$refs[`originRef`].focus();
                        else that.$refs[`countRef`].focus();
                        break;
                    case 'Origin':
                        that.$refs[`countRef`].focus();
                        break;
                    case 'Count':
                        that.$refs[`unitSelect`].focus();
                        break;
                    case 'Unit':
                        if (that.$refs[`unitSelect`]) that.$refs[`unitSelect`].blur();
                        that.$refs[`marketPirceRef`].focus();
                        break;
                    case 'MarketPrice':
                        that.$refs[`remarkRef`].focus();
                        break;
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgList.length <= 1)
                    that.$util.getParentOrgs().then(data => {
                        that.orgList = data;
                    });
            }
        },
        orgChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.orgList.length; i++) {
                    if (val == that.orgList[i].Id) {
                        that.submitData.OrgName = that.orgList[i].Name;
                        break;
                    }
                }
            } else {
                that.submitData.OrgName = '';
            }
        },
        getSetsData() {
            this.columnShowSets = [];
            this.$util.getTBSetsForShow(this.tableCode).then(data => {
                data.forEach(item => {
                    let colums = {
                        IsShow: item.IsShow,
                        Width: item.Width,
                        ColumnName: item.ColumnName,
                        ColumnCode: item.ColumnCode,
                        SortNum: item.SortNum,
                        IsSort: item.IsSort
                    };

                    this.columnShowSets.push(colums);
                });
            });
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getJointSearchSets() {
            this.$util.getJointSearchSetsData(true).then(data => {
                data.forEach(item => {
                    if (item.IsSeparator) {
                        this.separator = item.Separator;
                        return;
                    }
                });
            });
        },
        /**
         * 表格滚动
         * 只有在滚动到底部，并且下方还有数据的情况下刷新
         */
        tableLoad({ scrollTop, scrollLeft }, event) {
            var t = event.currentTarget.scrollTop; // 表格内容已滚动的高度
            var s = event.currentTarget.scrollHeight; // 表格内容撑起的高度
            var c = event.currentTarget.clientHeight; // 表格视窗高度 即wraper
            if (scrollTop > this.scrollTop && !this.stopFresh && t + c >= s - 50) {
                //第一页还没有数据就去请求第二页，想太多了吧`(*>﹏<*)′
                if (this.tableData && this.tableData.length > 0) {
                    this.searchData.page += 1;
                    if (scrollTop !== 0) this.scrollTop = scrollTop;
                    this.scrollLeft = scrollLeft;
                } else {
                    this.searchData.page = 1;
                    this.scrollTop = 0;
                    this.scrollLeft = 0;
                }
                this.getAPTableData();
            }
        },
        downKeyToLoad() {
            if (this.tableData && this.tableData.length > 0) {
                this.searchData.page += 1;
            } else {
                this.searchData.page = 1;
            }
            this.getAPTableData();
        },
        getAPTableData() {
            if (this.searchData.Symbol) {
                if (this.searchData.Symbol == 'between') {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                    if (isNaN(this.searchData.Invent2)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                } else {
                    if (isNaN(this.searchData.Invent1)) {
                        this.$util.warningMsg('请输入正确的库存数');
                        return;
                    }
                }
            } else {
                if (!this.searchData.Invent1) this.searchData.Invent1 = 0;
                if (!this.searchData.Invent2) this.searchData.Invent2 = 0;
            }
            if (this.isOriginSort && !this.searchData.SortProp) {
                this.searchData.SortProp = 'Origin';
                this.searchData.SortType = 'descending';
            }
            this.searchData.CId = this.submitData.EntpCusId;
            this.searchData.SId = this.submitData.WarehouseId;
            if (this.SelectedData && this.SelectedData.length > 0) {
                this.searchData.SelectedData = this.SelectedData;
            }
            if (this.searchData.page == 1) {
                this.searchParams = {
                    ...this.searchData
                };
            } else {
                this.searchParams.page = this.searchData.page;
            }
            this.searchLoading = true;
            this.stopFresh = true;
            let url = '';

            if (this.isUseSE)
            {
                url = '/api/EntpGoods/GetGoodsListForMuilPurOrder_v3';

                this.searchParams.ShowSalesOutWHCout = this.columnShowSets.findIndex(x=>x.ColumnCode == 'SalesOutWHCout') !== -1;
                this.searchParams.ShowPlanPurchase = this.columnShowSets.findIndex(x=>x.ColumnCode == 'PlanPurchase') !== -1;
                this.searchParams.ShowIntenCount = this.columnShowSets.findIndex(x=>x.ColumnCode == 'IntenCount') !== -1;

            }
            else url = '/api/EntpGoods/GetGoodsListForEditOrder_V4'; //GetGoodsForPurOrder_V3
            //获取在订数据
            //if (this.type == 8) url = '/api/EntpGoods/GetEntpIntentPartList_V3';
            this.$util
                .axiosPost({
                    url: url,
                    data: this.searchParams,
                    hideLoading: true
                })
                .then(res => {
                    this.searchLoading = false;
                    let data = res.data.GoodsList;
                    this.tableDataLength = res.count;
                    if (!data) {
                        if (this.searchData.page == 1) this.tableData = [];
                        return;
                    }

                    if(!this.isUseSE){
                        for (let i = 0; i < data.length; i++) {
                            data[i].LoadSpaceInvent = true;
                            //防止出现NaN在页面
                            data[i].OrderWaitOutQuantity = 0;
                            data[i].POrderWaitInQuantity = 0;
                        }
                    }
                    
                    let list = [...this.tableData, ...data];
                    const maps = new Map();
                    list = list.filter(m => !maps.has(m.EntpTempGoodsId) && maps.set(m.EntpTempGoodsId, 1));
                    //因为接口的原因，返回前后两页数据有重复，所以在这里做去重
                    this.tableData = list;

                    if (this.dataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.dataList.findIndex(f => f.EntpTempGoodsId == goods.EntpTempGoodsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                    this.stopFresh = data.length < this.searchData.limit;

                    if(!this.isUseSE){
                        let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
                        let poiqIsShow = this.isExObj('POrderWaitInQuantity');
                        let ppIsShow = this.isExObj('PlanPurchase');
                        let icIsShow = this.isExObj('IntenCount');
                        let rIsShow = this.isExObj('Remaining');
                        let sIsShow = this.isExObj('SalesOutWHCout');

                        if (owoqIsShow || poiqIsShow || ppIsShow || icIsShow || rIsShow || sIsShow) {
                            this.getOtherData(data);
                        }
                    }
                })
                .catch(e => {
                    this.searchLoading = false;
                });
        },
        async getOtherData(data) {
            let that = this;
            if (data && data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    that.loopGetData(data[i].EntpTempGoodsId);
                    await that.$util.sleep(100);
                }
                //使用表格方法更新数据，因为浏览器的兼容性，某些浏览器数据更新了但是页面线上还没有边，需要点击其它地方或滚动条滚动一下才触发变化，比如留余数一列
                this.$refs.multipleTable.updateData();
            }
        },
        loopGetData(id) {
            let that = this;
            let url = '';
            if (that.isUseSE) url = '/api/EntpGoods/GetAfteSearchPartForSE_V2';
            else url = '/api/EntpGoods/GetAfteSearchPartData_V4';

            let owoqIsShow = this.isExObj('OrderWaitOutQuantity');
            let poiqIsShow = this.isExObj('POrderWaitInQuantity');
            let ppIsShow = this.isExObj('PlanPurchase');
            let icIsShow = this.isExObj('IntenCount');
            let sIsShow = this.isExObj('SalesOutWHCout');
            that.$util
                .axiosGet({
                    url: url,
                    data: {
                        goodsId: id,
                        sId: that.searchData.SId,
                        isShowPlanPur: ppIsShow,
                        isShowOrderWaitOut: owoqIsShow,
                        isShowPOrderWaitIn: poiqIsShow,
                        isShowInven: icIsShow,
                        isShowSalesWHCout: sIsShow,
                        InStartDate: that.searchData.InStartDate,
                        InEndDate: that.searchData.InEndDate
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.tableData.forEach(item => {
                        if (item.EntpTempGoodsId == data.GoodsId) {
                            item.LoadSpaceInvent = false;
                            item.SalesOutWHCout = data.SalesOutWHCout;
                            item.OrderWaitOutQuantity = data.OrderWaitOutQuantity;
                            item.POrderWaitInQuantity = data.POrderWaitInQuantity;
                            item.IntenCount = data.IntenCount;
                            item.PlanPurchase = data.PlanPurchase;
                            item.SeriesCount = data.SeriesCount;
                            item.IsCommonSeries = data.IsCommonSeries;
                            if (that.isUseSE) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            if (!that.submitData.WarehouseId) {
                                item.Inventory = data.StorageInventory;
                                item.StorageInventory = data.StorageInventory;
                            }
                            return;
                        }
                    });
                })
                .catch(() => { });
        },
        showTableSetDialog() {
            this.tableSetsVisible = true;
        },
        onDateTimeSelect(val) {
            if (val != null) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                GoodDesc: '',
                AutoSerise: '',
                Brand: '',
                BrandName: [],
                Size: '',
                Cate: [],
                page: 1,
                limit: 15,
                CId: '',
                SId: '',
                SortProp: '',
                SortType: '',
                Source: '2',
                JointSearch: '',
                Symbol: '',
                Invent1: 0,
                Invent2: 0,
                Origin: '',
                SearchType: 2,
                InStartDate: '',
                InEndDate: ''
            };
            this.dateTimes = [];
            this.isSearch = false;
        },
        sdthandleChange(val) {
            if (val) {
                this.searchData.InStartDate = val[0];
                this.searchData.InEndDate = val[1];
            } else {
                this.searchData.InStartDate = '';
                this.searchData.InEndDate = '';
            }
        },
        handleSearch() {
            let that = this;
            that.searchData.page = 1;
            that.dataindex = -1;
            that.tableData = [];
            that.isSearch = true;
            that.scrollTop = 0;

            if (!that.searchLoading) {
                that.getAPTableData();
                that.$refs.multipleTable.clearSort();
            }
            if (that.searchVisible) {
                that.searchVisible = false;
                that.isStartSearch = false;
            }
        },
        closeSearchDialog() {
            this.isStartSearch = false;
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.loading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        tableRowClassName({ row, rowIndex }) {
            //把每一行的索引放进row
            row.index = rowIndex;
        },
        rowClick(row, column, event) {
            let that = this;
            that.dataindex = row.index;
            that.currentRow = row;
            if(that.historySalesVisible) that.showSalesHistories();
            if(that.historyPurVisible) that.showPurHistories();
            if(that.inqHistoryVisible) that.showIntentDatas();
            if(that.intenHistoryVisible) that.showIntentCountDatas();
            that.getInvenDatas(row);
        },
        getInvenDatas(row) {
            let that = this;
            if (!row) return;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetGoodsStorageInvens',
                    data: {
                        GoodsId: row.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    if (!data) {
                        return;
                    }
                    that.isShowSummary = true;
                    that.summaryList = data;
                })
                .catch(() => { });
        },
        // 列表双击打开弹框
        dblChooseAps(e) {
            let that = this;
            //先获取一些数据
            if ([e][0]) {
                that.rowFormLoading = true;
                that.rowVisible = true;
                that.isStartConfirm = true;
                that.$util.getGoodsDataForConfirm_V3(e.EntpTempGoodsId, '', that.submitData.EntpCusId, '2').then(data => {
                    if (data) {
                        that.rowForm = {
                            ...[e][0],
                            _price: that.type != 8 ? (data.LatestPurPrice ? data.LatestPurPrice : e.CostPrice) : e.IntenPrice,
                            _count: 1,
                            _referencePrice: data.ReferencePrice ? data.ReferencePrice : e.CostPrice,
                            Remark:''
                        };
                    }
                    that.selectAutoHandle('confirm_0');
                    that.rowFormLoading = false;
                });
            }
        },
        rowConfirm() {
            let that = this;
            let item = that.rowForm;
            let sIdx = that.tableData.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (sIdx > -1) {
                that.tableData[sIdx].IsSelected = true;
            }
            let fIdx = that.dataList.findIndex(f => f.EntpTempGoodsId === item.EntpTempGoodsId);
            if (fIdx > -1) {
                that.dataList[fIdx].Count = item._count;
                that.dataList[fIdx].MarketPrice = item._price;
                that.dataList[fIdx].Remark = item.Remark;
            } else {
                let newGoods = {};
                newGoods = {
                    ReferencePrice: item.ReferencePrice,
                    EntpTempGoodsId: item.EntpTempGoodsId,
                    APCode: item.APCode,
                    GoodName: item.GoodName,
                    GoodNameItem: item.GoodName,
                    AutoSerise: item.AutoSerise,
                    AutoSeriseItem: item.AutoSerise,
                    Count: item._count,
                    MarketPrice: item._price,
                    SalePrice: item.MarketPrice,
                    Unit: item.Unit,
                    Remark: item.Remark,
                    CodeRepeat: false,
                    Inventory: item.StorageInventory,
                    StorageInventory: item.StorageInventory,
                    WarehousedCount: 0,
                    OrderWaitOutQuantity: item.OrderWaitOutQuantity,
                    POrderWaitInQuantity: item.POrderWaitInQuantity,
                    LatestSalesTime: item.LatestSalesTime,
                    LatestQuoteTime: item.LatestQuoteTime,
                    State: 0,
                    canEdit: true,
                    IntenCount: item.IntenCount,
                    CostPrice: item.CostPrice,
                    Origin: item.Origin,
                    Size: item.Size,
                    Brand: item.Brand,
                };
                //移除最后一个空的配件
                if (that.dataList.length > 0 && !that.dataList[that.dataList.length - 1].EntpTempGoodsId) {
                    that.dataList.splice(that.dataList.length - 1, 1);
                }
                that.dataList.push(newGoods);
            }
            that.priceChange();
            that.rowVisible = false;
            that.isStartConfirm = false;
        },
        rowClose() {
            this.rowVisible = false;
            this.isStartConfirm = false;
            this.rowForm = {};
        },
        // showIntentDatas(id) {
        //     if (id) {
        //         if (this.inqHistoryVisible) {
        //             this.$refs.APInquiryHistory.updateTableData(id);
        //         } else {
        //             this.hisGoodsId = id;
        //             this.inqHistoryVisible = true;
        //         }
        //     }
        // },
        //询价历史
        showIntentDatas() {
            let that = this;
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                if(!that.inqHistoryVisible){
                    that.inqHistoryVisible = true;
                }else{
                    let gId = that.$refs.APInquiryHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        this.$refs.APInquiryHistory.updateTableData(this.goodsId);
                }
            }
        },
        //在订历史
        showIntentCountDatas(row) {
            let that = this;
            if(row){
                that.currentRow = row;
            }
            if (that.currentRow && that.currentRow.EntpTempGoodsId) {
                this.goodsId = that.currentRow.EntpTempGoodsId;
                if(!that.intenHistoryVisible){
                    that.intenHistoryVisible = true;
                }else{
                    let gId = that.$refs.APIntenHistory.EntpTempGoodsId
                    if(this.goodsId != gId)
                        this.$refs.APIntenHistory.updateTableData(this.goodsId);
                }
                return;
            }
        },
        showNeedInData(item) {
            if (item.EntpTempGoodsId && !this.needInDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedITitle = '【配件待入数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needInDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needInDataVisible) {
                this.$refs.APNeedInDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        showNeedOutData(item) {
            if (item.EntpTempGoodsId && !this.needOutDataVisible) {
                this.EntpTempGoodsId = item.EntpTempGoodsId;
                this.NeedOTitle = '【配件待出数据】配件编码：' + item.APCode + ' —— 配件名称：' + item.GoodName;
                this.needOutDataVisible = true;
            } else if (item.EntpTempGoodsId && this.needOutDataVisible) {
                this.$refs.APNeedOutDatas.updateTableData(item.EntpTempGoodsId);
            }
        },
        closeJointDialog() {
            this.jointSetVisible = false;
        },
        jointSets() {
            this.jointSetVisible = true;
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order ? event.order == "asc" ? "ascending":event.order : '';
            if (this.searchData.SortType == '') this.searchData.SortProp = '';
            this.searchData.page = 1;
            this.dataindex = -1;
            this.tableData = [];
            this.scrollTop = 0;
            this.scrollLeft = 0;
            this.getAPTableData();
        },
        searchGoodName(key, cb) {
            if (![undefined].includes(key)) {
                this.goodNameForm.Page = 1;
                this.goodNameForm.stopLoad = false;
                this.goodNameForm.key = key;
                this.goodNameOptions = [];
            }
            if (cb) {
                this.nameCallBack = cb;
            }
            if (this.goodNameForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.goodNameForm.key, 1, this.goodNameForm.Page, this.goodNameForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.goodNameForm.stopLoad = data.length < this.goodNameForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = [...this.goodNameOptions, ...arr];
                if (this.nameCallBack) {
                    this.nameCallBack(this.goodNameOptions);
                }
            });
        },
        searchGoodNameLoad() {
            this.goodNameForm.Page += 1;
            this.searchGoodName();
        },
        searchAutoSerise(key, cb) {
            if (![undefined].includes(key)) {
                this.autoSeriseForm.Page = 1;
                this.autoSeriseForm.stopLoad = false;
                this.autoSeriseForm.key = key;
                this.autoSeriseOptions = [];
            }
            if (cb) {
                this.autoCallBack = cb;
            }
            if (this.autoSeriseForm.stopLoad) return;
            this.$util.searchPartAttr(this.autoSeriseForm.key, 2, this.autoSeriseForm.Page, this.autoSeriseForm.Limit).then(data => {
                let arr = [];
                if (data) {
                    this.autoSeriseForm.stopLoad = data.length < this.autoSeriseForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = [...this.autoSeriseOptions, ...arr];
                if (this.autoCallBack) {
                    this.autoCallBack(this.autoSeriseOptions);
                }
            });
        },
        searchAutoSeriseLoad() {
            this.autoSeriseForm.Page += 1;
            this.searchAutoSerise();
        },
        searchAPCode(key, cb) {
            if (![undefined].includes(key)) {
                this.apCodeForm.Page = 1;
                this.apCodeForm.stopLoad = false;
                this.apCodeForm.key = key;
                this.apCodeOptions = [];
            }
            if (cb) {
                this.apCodeCallBack = cb;
            }
            if (this.apCodeForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.apCodeForm.key, 0, this.apCodeForm.Page, this.apCodeForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.apCodeForm.stopLoad = data.length < this.apCodeForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.apCodeOptions = [...this.apCodeOptions, ...arr];
                if (this.apCodeCallBack) {
                    this.apCodeCallBack(this.apCodeOptions);
                }
            });
        },
        searchAPCodeLoad() {
            this.apCodeForm.Page += 1;
            this.searchAPCode();
        },
        searchOrigin(key, cb) {
            if (![undefined].includes(key)) {
                this.originForm.Page = 1;
                this.originForm.stopLoad = false;
                this.originForm.key = key;
                this.originOptions = [];
            }
            if (cb) {
                this.originCallBack = cb;
            }
            if (this.originForm.stopLoad) return;
            this.optionLoading = true;
            this.$util.searchPartAttr(this.originForm.key, 3, this.originForm.Page, this.originForm.Limit).then(data => {
                this.optionLoading = false;
                let arr = [];
                if (data) {
                    this.originForm.stopLoad = data.length < this.originForm.Limit;
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.originOptions = [...this.originOptions, ...arr];
                if (this.originCallBack) {
                    this.originCallBack(this.originOptions);
                }
            });
        },
        searchOriginLoad() {
            this.originForm.Page += 1;
            this.searchOrigin();
        },
        stopSearch() {
            this.canSearch = false;
        },
        refreshResult() {
            this.searchData.page = 1;
            this.handleSearch();
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                that.$util.getPurOrderSetSources().then(data => {
                    that.cusSourcesList = data;
                });
            }
        },
        sourceChange(val) {
            let that = this;
            if (val) {
                for (let i = 0; i < that.cusSourcesList.length; i++) {
                    if (val == that.cusSourcesList[i].Value) {
                        that.submitData.CusSourcesName = that.cusSourcesList[i].Text;
                        break;
                    }
                }
            } else {
                that.submitData.CusSourcesName = '';
            }
        },
    }
};
</script>
<style lang="less" scoped>
.invens-summary {
    display: flex;
    flex-direction: row;
    height: 40px;
    line-height: 30px;
    padding: 0 20px;
    font-size: 14px;
    margin-left: -1px;
    border: 1px solid rgb(226, 226, 226);
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;

    .title {
        font-size: 16px;
        font-weight: 600;
    }

    .summary-item {
        display: flex;
        flex-direction: row;

        .sname {
            font-size: 18px;
        }

        .scount {
            font-size: 20px;
            font-weight: 700px;
            color: #ea7060;
            margin-right: 20px;
        }
    }
}

.purorder-v3 {
    padding: 10px 20px 0px 20px;
}

.el-form-item {
    margin-bottom: 0 !important;
}

.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}

.section-magin {
    margin-bottom: 5px;
}

.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }

    .project-iven {
        width: 50px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.special-border {
    height: 100%;
    border-radius: 3px;
    border: 1px solid #ffcc00;
}

.head-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .color-red {
        margin-right: 4px;
    }

    .sort-view {
        display: flex;
        flex-direction: column;

        i {
            line-height: 8px;
            cursor: pointer;
        }

        .active {
            color: #409eff;
        }
    }
}

.saveProgress {
    position: absolute;
    top: 38%;
    left: 45%;
    z-index: 99999;
}

.customer-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .grid-content {
        flex: 1;
    }

    .customer-checked {
        margin-left: 24px;
    }
}

.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}

.discount-zone {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .el-input-number {
        width: 110px;

        .el-input__inner {
            height: 32px;
        }
    }

    .el-select {
        margin-right: 12px;

        .el-input__inner {
            width: 110px;
            height: 32px;
            color: red;
        }

        .el-input__suffix {
            top: 4px;
        }

        .is-focus {
            .el-input__suffix {
                top: -4px;
            }
        }
    }
}

#search-dc-dialog,
#comfirm-ap-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.search-set-btn {
    margin-top: 4px;
    height: 24px;
    width: 25px;
    line-height: 24px;
    padding: 0;
    margin-right: 5px;
    margin-left: 2px;
}
</style>

<style lang="less">
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
.el-autocomplete-suggestion {
    width: 300px !important;
}

.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }

    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}

.pop-cls {
    font-size: 18px;
    padding: 10px 12px;
    color: #fff;
    background-color: #303133;

    .popper__arrow {
        color: #303133;
    }
}

#search-dialog {
    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        overflow: auto;
    }
}

#search-dialog::-webkit-scrollbar {
    display: none;
}

.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 10px;
    }
}

.el-col {
    border-radius: 4px;
}

.bg-purple-dark {
    background: #99a9bf;
}

.bg-purple {
    background: #d3dce6;
}

.bg-purple-light {
    background: #e5e9f2;
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}

.search-in-order {
    .elx-table {

        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                td {
                    height: 26px;
                    line-height: 26px;
                }
            }

            .elx-cell {
                height: 26px;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }
    }
}

.pur-order-edit {
    .elx-table {

        .elx-body--row.row--hover,
        .elx-body--row.row--hover.row--stripe {
            background-color: #dcdee1;
        }

        .elx-table--header-wrapper {
            .elx-header--row {
                .elx-header--column {
                    height: 34px;
                }

                .elx-cell {
                    padding: 4px 12px 0;
                }
            }
        }

        .elx-table--body-wrapper {
            .elx-body--row {
                .table-sort {
                    .elx-cell {
                        padding: 4px 12px 0;
                    }
                }

                .div-padding-12 {
                    padding: 4px 8px 0;
                }

                .div-margin-op {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }

                .operate {
                    padding: 0 12px;
                }

                td {
                    height: 26px;
                }
            }

            .elx-cell {
                padding: 0;
                height: 32px;
            }

            .el-button--small {
                padding: 5px 15px;
                margin: 3px 9px 0 0;
            }
        }

        .elx-table--footer-wrapper {
            margin-top: 0 !important;
        }

        .elx-table--body-wrapper {
            padding-bottom: 180px !important;
        }
    }

    .pur-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .purcounts-input-cell {
        .el-input-number {
            width: 100%;
        }

        .el-input {
            .el-input__inner {
                padding-left: 0;
                padding-right: 20px;
            }
        }

        .el-input-number__decrease,
        .el-input-number__increase {
            width: 20px;
        }
    }

    .unit-input-cell {
        .el-input {
            .el-input__inner {
                padding-right: 20px;
            }
        }
    }

    .pur-apcode {
        .el-tag {
            height: 24px;
            line-height: 22px;
            margin-left: 8px;
        }

        .sp-i {
            height: 24px;
            margin-left: -6px;
            margin-right: 2px;
        }

        .el-icon-info {
            color: #87a7d6;
            font-size: 18px;
            vertical-align: top;
            cursor: pointer;
            margin-top: 2px;
        }
    }
}

.mbox_ext {
    width: auto !important;
}

.warhouse {
    margin-right: 60px;
}
</style>
